(function () {
  'use strict';

  const $ = (sel, root) => (root || document).querySelector(sel);
  const $$ = (sel, root) => Array.from((root || document).querySelectorAll(sel));

  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2);
    const format = window.moneyFormat || '${{amount}}';
    return format.replace(/\{\{\s*\w+\s*\}\}/, amount);
  }

  /* ------------------------------------------------------------ mobile nav */

  const menuToggle = $('[data-menu-toggle]');
  const mobileNav = $('[data-mobile-nav]');

  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', () => {
      const open = mobileNav.dataset.open === 'true';
      mobileNav.dataset.open = String(!open);
      menuToggle.setAttribute('aria-expanded', String(!open));
      document.body.style.overflow = open ? '' : 'hidden';
    });
  }

  /* --------------------------------------------------------- nav dropdown */

  const drops = $$('[data-nav-drop]');

  if (drops.length) {
    const closeAll = (except) => {
      drops.forEach((d) => {
        if (d === except) return;
        d.classList.remove('is-open');
        const btn = $('[data-nav-drop-toggle]', d);
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });
    };

    drops.forEach((drop) => {
      const btn = $('[data-nav-drop-toggle]', drop);
      const set = (open) => {
        drop.classList.toggle('is-open', open);
        if (btn) btn.setAttribute('aria-expanded', String(open));
        if (open) closeAll(drop);
      };

      if (btn) {
        btn.addEventListener('click', () => set(!drop.classList.contains('is-open')));
      }

      // Hover is a convenience on top of the button, not the only way in —
      // touch and keyboard have no hover.
      drop.addEventListener('mouseenter', () => set(true));
      drop.addEventListener('mouseleave', () => set(false));
      drop.addEventListener('focusout', (e) => {
        if (!drop.contains(e.relatedTarget)) set(false);
      });
    });

    document.addEventListener('click', (e) => {
      if (!e.target.closest('[data-nav-drop]')) closeAll(null);
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeAll(null);
    });
  }

  /* ------------------------------------------------------ discord prompt */

  const dprompt = $('[data-discord-prompt]');

  if (dprompt) {
    const key = 'picovr:discord:' + dprompt.dataset.key;

    let dismissed = false;
    try { dismissed = localStorage.getItem(key) === '1'; } catch (e) { /* private mode */ }

    const close = (remember) => {
      dprompt.classList.remove('is-in');
      // Wait for the slide-out before removing it from the layout.
      setTimeout(() => { dprompt.hidden = true; }, 320);
      if (remember) {
        try { localStorage.setItem(key, '1'); } catch (e) { /* non-fatal */ }
      }
    };

    // Shopify's cookie consent banner occupies the same corner and paints
    // above this. Showing on top of a consent dialog would be wrong, so wait
    // for it to go before appearing at all.
    // Only hold back if the consent banner would actually sit on top of the
    // prompt. They are in opposite corners by default, so waiting for consent
    // in every case just meant the prompt never appeared until the banner was
    // answered — which for most visitors is never.
    const consentBlocking = () => {
      const banner = document.getElementById('shopify-pc__banner');
      if (!banner) return false;
      const b = banner.getBoundingClientRect();
      if (!b.width || !b.height) return false;
      if (getComputedStyle(banner).visibility === 'hidden') return false;

      // Measure the prompt where it will land, without revealing it.
      const wasHidden = dprompt.hidden;
      dprompt.hidden = false;
      const p = dprompt.getBoundingClientRect();
      dprompt.hidden = wasHidden;

      const gap = 12;
      return !(
        p.right < b.left - gap ||
        p.left > b.right + gap ||
        p.bottom < b.top - gap ||
        p.top > b.bottom + gap
      );
    };

    const show = () => {
      dprompt.hidden = false;
      // Next frame, so the transition runs rather than snapping in. rAF is
      // paused in a background tab, so a timer backs it up — otherwise the
      // prompt un-hides but stays at opacity 0 until the tab is refocused.
      const reveal = () => dprompt.classList.add('is-in');
      requestAnimationFrame(reveal);
      setTimeout(reveal, 60);
    };

    if (!dismissed) {
      const delay = Math.max(0, Number(dprompt.dataset.delay) || 0) * 1000;
      setTimeout(() => {
        if (!consentBlocking()) return show();
        const poll = setInterval(() => {
          if (consentBlocking()) return;
          clearInterval(poll);
          show();
        }, 1000);
      }, delay);
    }

    $('[data-discord-dismiss]', dprompt).addEventListener('click', () => close(true));

    // Taking the invite counts as answering the prompt.
    const join = $('[data-discord-join]', dprompt);
    if (join) join.addEventListener('click', () => close(true));

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !dprompt.hidden) close(true);
    });
  }

  /* ------------------------------------------------------- copy to clipboard */

  // Discord has no add-by-username link, so the handle is copied for pasting
  // into Add Friend.
  $$('[data-copy]').forEach((btn) => {
    const label = $('[data-copy-label]', btn);
    let revert;

    const fallback = (text) => {
      // navigator.clipboard needs a secure context; this keeps the button
      // working on plain http (a local preview, say).
      const ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.cssText = 'position:fixed;top:-100vh;opacity:0';
      document.body.appendChild(ta);
      ta.select();
      let ok = false;
      try {
        ok = document.execCommand('copy');
      } catch (e) {
        ok = false;
      }
      document.body.removeChild(ta);
      return ok;
    };

    const done = () => {
      btn.classList.add('is-copied');
      if (label) label.textContent = btn.dataset.copyDone || 'Copied';
      clearTimeout(revert);
      revert = setTimeout(() => {
        btn.classList.remove('is-copied');
        if (label) label.textContent = btn.dataset.copyIdle || 'Copy';
      }, 2200);
    };

    btn.addEventListener('click', () => {
      const text = btn.dataset.copy;
      if (!text) return;

      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(text).then(done, () => {
          if (fallback(text)) done();
        });
      } else if (fallback(text)) {
        done();
      }
    });
  });

  /* -------------------------------------------------- release version tags */

  const versionEls = $$('[data-gh-version]');

  if (versionEls.length) {
    // Cached for a day: the GitHub API allows 60 unauthenticated calls an
    // hour per IP, and a release tag does not change often enough to justify
    // a request on every page view.
    const DAY = 86400000;

    const cached = (repo) => {
      try {
        const raw = localStorage.getItem('picovr:ghver:' + repo);
        if (!raw) return null;
        const { tag, at } = JSON.parse(raw);
        return Date.now() - at < DAY ? tag : null;
      } catch (e) { return null; }
    };

    const store = (repo, tag) => {
      try {
        localStorage.setItem('picovr:ghver:' + repo, JSON.stringify({ tag, at: Date.now() }));
      } catch (e) { /* private mode */ }
    };

    // Group elements so one request covers every mention of a repo.
    const byRepo = new Map();
    versionEls.forEach((el) => {
      const repo = el.dataset.repo;
      if (!repo) return;
      if (!byRepo.has(repo)) byRepo.set(repo, []);
      byRepo.get(repo).push(el);
    });

    byRepo.forEach((els, repo) => {
      const apply = (tag) => els.forEach((el) => { el.textContent = tag; });

      const hit = cached(repo);
      if (hit) return apply(hit);

      fetch('https://api.github.com/repos/' + repo + '/releases/latest', {
        headers: { Accept: 'application/vnd.github+json' }
      })
        .then((r) => (r.ok ? r.json() : Promise.reject(r.status)))
        .then((data) => {
          if (!data || !data.tag_name) return;
          apply(data.tag_name);
          store(repo, data.tag_name);
        })
        // Rate limited or offline: the version rendered by Liquid stays put.
        .catch(() => {});
    });
  }

  /* ------------------------------------------------------------ set finder */

  $$('[data-set-finder]').forEach((root) => {
    const questions = $$('[data-sf-question]', root);
    const steps = $$('[data-sf-step]', root);
    const result = $('[data-sf-result]', root);
    const cards = $$('[data-sf-card]', result);
    const progress = $('[data-sf-progress]', root);

    // One answer per question, each contributing a minimum tracker count.
    const answers = new Array(questions.length).fill(null);
    let current = 0;

    function showQuestion(i) {
      current = i;
      questions.forEach((q, n) => (q.hidden = n !== i));
      steps.forEach((s, n) => s.classList.toggle('is-on', n <= i));
      result.hidden = true;
      progress.hidden = false;
    }

    function finish() {
      // The recommendation is the smallest set that satisfies every answer,
      // so one demanding answer lifts the whole result rather than averaging
      // away.
      const needed = Math.max(...answers.filter((a) => a !== null));
      const sorted = cards.slice().sort((a, b) => Number(a.dataset.count) - Number(b.dataset.count));
      const match = sorted.find((c) => Number(c.dataset.count) >= needed) || sorted[sorted.length - 1];

      cards.forEach((c) => (c.hidden = c !== match));
      questions.forEach((q) => (q.hidden = true));
      progress.hidden = true;
      result.hidden = false;

      const why = $('[data-sf-why]', match);
      if (why) {
        why.textContent = (window.themeStrings.setFinderWhy || 'Needs at least [n] trackers.')
          .replace('[n]', needed);
      }

      result.scrollIntoView({ block: 'nearest' });
    }

    questions.forEach((q, i) => {
      $$('[data-sf-option]', q).forEach((opt) => {
        opt.addEventListener('click', () => {
          $$('[data-sf-option]', q).forEach((o) => o.setAttribute('aria-pressed', String(o === opt)));
          answers[i] = Number(opt.dataset.min);
          if (i + 1 < questions.length) showQuestion(i + 1);
          else finish();
        });
      });

      const back = $('[data-sf-back]', q);
      if (back) back.addEventListener('click', () => showQuestion(Math.max(0, i - 1)));
    });

    const restart = $('[data-sf-restart]', root);
    if (restart) {
      restart.addEventListener('click', () => {
        answers.fill(null);
        $$('[data-sf-option]', root).forEach((o) => o.setAttribute('aria-pressed', 'false'));
        showQuestion(0);
        root.scrollIntoView({ block: 'nearest' });
      });
    }
  });

  /* --------------------------------------------------- tracker placement */

  $$('[data-tracker-placement]').forEach((root) => {
    const setButtons = $$('[data-tp-set]', root);
    const points = $$('[data-tp-point]', root);
    const status = $('[data-tp-status]', root);

    function apply(count) {
      let on = 0;
      points.forEach((p) => {
        // A point lights up once the chosen set is big enough to include it.
        const active = Number(p.dataset.from) <= count;
        p.classList.toggle('is-on', active);
        if (active) on += 1;
      });

      if (status) {
        status.textContent = ((window.themeStrings && window.themeStrings.placementStatus) || '[on] of [count]')
          .replace('[on]', on)
          .replace('[count]', count);
      }
    }

    setButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        setButtons.forEach((b) => b.setAttribute('aria-selected', String(b === btn)));
        apply(Number(btn.dataset.count));
      });
    });

    const initial = setButtons.find((b) => b.getAttribute('aria-selected') === 'true') || setButtons[0];
    if (initial) apply(Number(initial.dataset.count));

    // Avatar picker. Only one image is in flow at a time, so the box always
    // matches the visible avatar and the point coordinates stay aligned.
    const picker = $('[data-tp-avatar]', root);
    const avatarImgs = $$('[data-tp-avatar-img]', root);

    // Avatars hold their arms at different angles, so a point can carry a
    // per-avatar position: "Left hand:8,53; Right hand:93,53". Anything not
    // listed falls back to the point's own coordinates.
    function place(img) {
      const overrides = {};
      (img.dataset.tpPoints || '').split(';').forEach((entry) => {
        const [name, coords] = entry.split(':');
        if (!name || !coords) return;
        const [x, y] = coords.split(',').map((n) => parseFloat(n));
        if (isFinite(x) && isFinite(y)) overrides[name.trim().toLowerCase()] = [x, y];
      });

      points.forEach((p) => {
        const o = overrides[(p.dataset.label || '').trim().toLowerCase()];
        p.style.left = (o ? o[0] : p.dataset.x) + '%';
        p.style.top = (o ? o[1] : p.dataset.y) + '%';
      });
    }

    if (avatarImgs.length) place(avatarImgs[0]);

    if (picker && avatarImgs.length) {
      picker.addEventListener('change', () => {
        avatarImgs.forEach((img) => {
          const on = img.dataset.tpAvatarImg === picker.value;
          img.classList.toggle('is-active', on);
          if (on) place(img);
        });
      });

      // A hidden lazy image is never fetched, so the first switch would show
      // an empty figure while it downloaded. Fetch the others once the page
      // itself has finished loading.
      const warm = () => avatarImgs.forEach((img) => img.removeAttribute('loading'));
      if (document.readyState === 'complete') warm();
      else window.addEventListener('load', warm, { once: true });
    }
  });

  /* --------------------------------------------------- battery calculator */

  $$('[data-battery-calc]').forEach((root) => {
    const board = $('[data-bc-board]', root);
    const battery = $('[data-bc-battery]', root);
    const custom = $('[data-bc-custom]', root);
    const mah = $('[data-bc-mah]', root);
    const runtimeEl = $('[data-bc-runtime]', root);
    const chargeEl = $('[data-bc-charge]', root);
    const warn = $('[data-bc-warn]', root);
    const boardNote = $('[data-bc-board-note]', root);
    const battNote = $('[data-bc-batt-note]', root);
    const basis = $('[data-bc-basis]', root);
    const drawWrap = $('[data-bc-draw-wrap]', root);
    const drawInput = $('[data-bc-draw]', root);

    if (!mah || !runtimeEl) return;

    const usable = Number(root.dataset.usable || 90) / 100;
    const chargeCurrent = Number(root.dataset.charge || 500);
    const hourWord = root.dataset.hour || 'h';
    const minuteWord = root.dataset.minute || 'min';

    function clock(hours) {
      const total = Math.round(hours * 60);
      const h = Math.floor(total / 60);
      const m = total % 60;
      if (!h) return m + ' ' + minuteWord;
      if (!m) return h + ' ' + hourWord;
      return h + ' ' + hourWord + ' ' + m + ' ' + minuteWord;
    }

    function update() {
      // A tracker version carries its own cell size; "custom" hands over to
      // the number input.
      const picked = battery ? battery.value : 'custom';
      const customCapacity = picked === 'custom';
      if (custom) custom.hidden = !customCapacity;
      const capacity = customCapacity ? Number(mah.value) : Number(picked);

      // Draw always comes from the board picker, including its own custom
      // option. A version with its own figure fills that in rather than
      // bypassing it, so what the tool is using is always on screen.
      const customDraw = board && board.value === 'custom';
      if (drawWrap) drawWrap.hidden = !customDraw;
      const draw = customDraw ? Number(drawInput.value) : board ? Number(board.value) : 0;

      const battOpt = battery ? battery.options[battery.selectedIndex] : null;
      if (battNote && battOpt) {
        battNote.textContent = battOpt.dataset.note || '';
        battNote.hidden = !battOpt.dataset.note;
      }
      if (boardNote && board) {
        const note = customDraw ? '' : board.options[board.selectedIndex].dataset.note || '';
        boardNote.textContent = note;
        boardNote.hidden = !note;
      }

      const ok = isFinite(capacity) && capacity > 0 && isFinite(draw) && draw > 0;

      if (warn) warn.hidden = ok;
      runtimeEl.textContent = ok ? clock((capacity * usable) / draw) : '—';
      if (chargeEl) {
        // Charging tapers off near the top, so the last stretch is slower
        // than a flat capacity/current would suggest.
        chargeEl.textContent = ok ? clock((capacity / chargeCurrent) * 1.2) : '—';
      }
      if (basis) {
        basis.textContent = ok ? (root.dataset.basis || 'Based on [n] mA').replace('[n]', draw) : '';
        basis.hidden = !ok;
      }
    }

    // Remembers the last board the visitor picked, so a version that fills in
    // its own draw can hand control back when they move off it.
    let lastProfile = board && board.value !== 'custom' ? board.value : null;
    let drawFromVersion = false;

    function versionChanged() {
      if (!board || !battery) return update();
      const opt = battery.options[battery.selectedIndex];
      const versionDraw = Number((opt && opt.dataset.draw) || 0);

      if (versionDraw > 0) {
        board.value = 'custom';
        if (drawInput) drawInput.value = versionDraw;
        drawFromVersion = true;
      } else if (drawFromVersion) {
        board.value = lastProfile !== null ? lastProfile : board.options[0].value;
        drawFromVersion = false;
      }
      update();
    }

    if (board) {
      board.addEventListener('change', () => {
        if (board.value !== 'custom') lastProfile = board.value;
        drawFromVersion = false;
        update();
      });
    }
    if (battery) battery.addEventListener('change', versionChanged);
    mah.addEventListener('input', update);
    if (drawInput) drawInput.addEventListener('input', update);

    versionChanged();
  });

  /* ------------------------------------------------------- spare parts finder */

  $$('[data-spare-parts]').forEach((root) => {
    const symptom = $('[data-sp-symptom]', root);
    const version = $('[data-sp-version]', root);
    const cards = $$('[data-sp-card]', root);
    const empty = $('[data-sp-empty]', root);
    if (!symptom || !cards.length) return;

    function show() {
      const want = symptom.value;
      const ver = version ? version.value : '';
      let shown = 0;

      // Several parts can answer one symptom — the right battery depends on which
      // tracker it came out of — so this shows every match rather than the first.
      cards.forEach((card) => {
        // A part with no versions listed fits everything, which is the sane
        // default for a strap or a dock that never changed between revisions.
        const fits = (card.dataset.fits || '').split(',').filter(Boolean);
        const versionOk = !ver || !fits.length || fits.indexOf(ver) > -1;
        const on = card.dataset.symptom === want && versionOk;
        card.hidden = !on;
        if (on) shown += 1;
      });

      if (empty) empty.hidden = shown > 0;
    }

    symptom.addEventListener('change', show);
    if (version) version.addEventListener('change', show);
    show();
  });

  /* -------------------------------------------------------- discord console */

  // The webhook URL lives in localStorage on this device and nowhere else. It is
  // a credential — anyone holding it can post to the channel as the bot — so it
  // must not go into a theme setting, where it would be in the page source of
  // every visitor and in the repo besides.
  const DISCORD_KEY = 'picovr-discord-webhook';
  const WEBHOOK_RE = /^https:\/\/(canary\.|ptb\.)?discord(app)?\.com\/api\/webhooks\/\d+\/[\w-]+$/;

  // Discord wants the colour as a decimal integer, not the hex a colour picker
  // gives. Anything unparseable falls back rather than sending a broken embed.
  function hexToInt(hex, fallback) {
    const m = /^#?([0-9a-f]{6})$/i.exec((hex || '').trim());
    return m ? parseInt(m[1], 16) : fallback;
  }

  // How Discord renders <t:unix:X>, used for the worked example under the tool.
  // These are its own format letters: f is what you get with no letter at all.
  const TIME_FMT = {
    t: { timeStyle: 'short' },
    T: { timeStyle: 'medium' },
    d: { dateStyle: 'short' },
    D: { dateStyle: 'long' },
    f: { dateStyle: 'long', timeStyle: 'short' },
    F: { dateStyle: 'full', timeStyle: 'short' },
  };

  function relativeWords(then, now) {
    const secs = Math.round((then - now) / 1000);
    const abs = Math.abs(secs);
    const units = [['year', 31536000], ['month', 2592000], ['day', 86400],
                   ['hour', 3600], ['minute', 60], ['second', 1]];
    for (const [name, size] of units) {
      if (abs >= size || name === 'second') {
        const n = Math.round(secs / size);
        try {
          return new Intl.RelativeTimeFormat(undefined, { numeric: 'auto' }).format(n, name);
        } catch (e) {
          return n + ' ' + name + (Math.abs(n) === 1 ? '' : 's');
        }
      }
    }
    return '';
  }

  $$('[data-discord-console]').forEach((root) => {
    const S = window.themeStrings || {};
    const connect = $('[data-dcon-connect]', root);
    const compose = $('[data-dcon-compose]', root);
    const urlField = $('[data-dcon-url]', root);
    const title = $('[data-dcon-title]', root);
    const link = $('[data-dcon-link]', root);
    const image = $('[data-dcon-image]', root);
    const colour = $('[data-dcon-color]', root);
    const message = $('[data-dcon-message]', root);
    const status = $('[data-dcon-status]', root);
    const channel = $('[data-dcon-channel]', root);
    const count = $('[data-dcon-count]', root);

    // Set by a template, otherwise the section default; the thumbnail has no
    // field of its own because it only ever arrives with a template.
    let thumb = '';

    const read = () => {
      try { return localStorage.getItem(DISCORD_KEY) || ''; } catch (e) { return ''; }
    };

    const pings = () => $$('[data-dcon-ping]', root).filter((b) => b.getAttribute('aria-pressed') === 'true');

    function mentionText() {
      return pings().map((b) => (b.dataset.everyone === 'true' ? '@everyone' : '<@&' + b.dataset.roleId + '>')).join(' ');
    }

    function paint() {
      const saved = read();
      connect.hidden = !!saved;
      compose.hidden = !saved;
      if (channel) {
        // The trailing token is the secret half, so only the id is ever shown.
        const id = saved ? (saved.match(/webhooks\/(\d+)\//) || [])[1] : null;
        channel.textContent = id
          ? (S.discordConnected || 'Connected to webhook [n]').replace('[n]', id)
          : (S.discordNotConnected || 'Not connected on this device.');
      }
      preview();
    }

    // Enough markdown to make the preview honest about what Discord will show.
    // Escaped first, so a stray < in a message cannot become markup here.
    function renderMd(text) {
      const safe = text
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      return safe
        .replace(/&lt;t:(\d+)(?::([tTdDfFR]))?&gt;/g, (m, unix, f) =>
          '<span class="dembed__time">' + renderTime(Number(unix) * 1000, f || 'f') + '</span>')
        .replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
        .replace(/(^|[^*])\*([^*]+)\*/g, '$1<em>$2</em>')
        .replace(/`([^`]+)`/g, '<code>$1</code>')
        .replace(/\n/g, '<br>');
    }

    function renderTime(ms, f) {
      const d = new Date(ms);
      if (f === 'R') return relativeWords(d.getTime(), Date.now());
      try { return d.toLocaleString(undefined, TIME_FMT[f] || TIME_FMT.f); }
      catch (e) { return d.toISOString(); }
    }

    function preview() {
      const bar = $('[data-dcon-pv-bar]', root);
      if (bar) bar.style.background = colour ? colour.value : root.dataset.color;

      const ping = $('[data-dcon-pv-ping]', root);
      if (ping) {
        const text = mentionText();
        ping.textContent = pings().map((b) => b.textContent.trim()).join(' ');
        ping.hidden = !text;
      }

      const t = $('[data-dcon-pv-title]', root);
      if (t) {
        t.textContent = title.value.trim();
        t.hidden = !title.value.trim();
        t.classList.toggle('is-link', !!link.value.trim());
      }

      const d = $('[data-dcon-pv-desc]', root);
      if (d) d.innerHTML = renderMd(message.value);

      const th = $('[data-dcon-pv-thumb]', root);
      if (th) {
        if (thumb) { th.src = thumb; th.hidden = false; } else { th.hidden = true; th.removeAttribute('src'); }
      }

      const big = $('[data-dcon-pv-image]', root);
      if (big) {
        const src = image ? image.value.trim() : '';
        if (src) { big.src = src; big.hidden = false; } else { big.hidden = true; big.removeAttribute('src'); }
      }

      const foot = $('[data-dcon-pv-footer]', root);
      const footText = root.dataset.footer || '';
      if (foot) {
        const stamp = root.dataset.timestamp === 'true'
          ? new Date().toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' })
          : '';
        const joined = [footText, stamp].filter(Boolean).join(' • ');
        $('[data-dcon-pv-footer-text]', root).textContent = joined;
        foot.hidden = !joined;
        const fi = $('[data-dcon-pv-footer-icon]', root);
        if (fi) {
          if (root.dataset.footerIcon) { fi.src = root.dataset.footerIcon; fi.hidden = false; }
          else fi.hidden = true;
        }
      }

      const auth = $('[data-dcon-pv-author]', root);
      if (auth) {
        const name = root.dataset.name || '';
        $('[data-dcon-pv-author-name]', root).textContent = name;
        auth.hidden = !name;
        const ai = $('[data-dcon-pv-author-icon]', root);
        if (ai) {
          if (root.dataset.avatar) { ai.src = root.dataset.avatar; ai.hidden = false; }
          else ai.hidden = true;
        }
      }

      if (count) count.textContent = String(message.value.length);
    }

    const say = (text, bad) => {
      if (!status) return;
      status.hidden = false;
      status.textContent = text;
      status.classList.toggle('form-status--error', !!bad);
      status.classList.toggle('form-status--success', !bad);
    };

    const save = $('[data-dcon-save]', root);
    if (save) {
      save.addEventListener('click', () => {
        const value = urlField.value.trim();
        const err = $('[data-dcon-url-error]', root);
        // Checked before storing so a typo fails here rather than silently on
        // every send afterwards.
        if (!WEBHOOK_RE.test(value)) {
          if (err) err.hidden = false;
          return;
        }
        if (err) err.hidden = true;
        try { localStorage.setItem(DISCORD_KEY, value); } catch (e) { /* private mode */ }
        urlField.value = '';
        paint();
      });
    }

    const forget = $('[data-dcon-forget]', root);
    if (forget) {
      forget.addEventListener('click', () => {
        try { localStorage.removeItem(DISCORD_KEY); } catch (e) { /* nothing stored */ }
        if (status) status.hidden = true;
        paint();
      });
    }

    $$('[data-dcon-ping]', root).forEach((btn) => {
      btn.addEventListener('click', () => {
        const on = btn.getAttribute('aria-pressed') === 'true';
        btn.setAttribute('aria-pressed', String(!on));
        btn.classList.toggle('is-on', !on);
        preview();
      });
    });

    $$('[data-dcon-template]', root).forEach((btn) => {
      btn.addEventListener('click', () => {
        title.value = btn.dataset.title || '';
        message.value = btn.dataset.body || '';
        link.value = btn.dataset.link || '';
        if (image) image.value = btn.dataset.image || '';
        if (colour) colour.value = btn.dataset.color || root.dataset.color;
        thumb = btn.dataset.thumb || '';
        $$('[data-dcon-template]', root).forEach((b) => b.classList.toggle('is-on', b === btn));
        preview();
        message.focus();
      });
    });

    [title, link, message, image, colour].forEach((el) => {
      if (el) el.addEventListener('input', preview);
    });

    const reset = $('[data-dcon-color-reset]', root);
    if (reset && colour) {
      reset.addEventListener('click', () => { colour.value = root.dataset.color; preview(); });
    }

    /* --- discord timestamps ------------------------------------------------
       <t:unix:X> renders in each reader's own timezone and language, so one of
       these is correct for everybody rather than for whoever typed it. */
    const when = $('[data-dcon-when]', root);
    const fmt = $('[data-dcon-format]', root);
    const code = $('[data-dcon-time-code]', root);
    const eg = $('[data-dcon-time-eg]', root);

    function stamp() {
      // datetime-local has no timezone, so it is read as local time — which is
      // what someone picking a time in their own calendar means.
      const ms = when && when.value ? new Date(when.value).getTime() : Date.now();
      return { unix: Math.floor(ms / 1000), ms: ms, f: fmt ? fmt.value : 'f' };
    }

    function timeTool() {
      if (!code) return;
      const s = stamp();
      const token = '<t:' + s.unix + ':' + s.f + '>';
      code.textContent = token;
      if (eg) eg.textContent = (S.discordTimeEg || 'Everyone sees: [n]').replace('[n]', renderTime(s.ms, s.f));
    }

    if (when) when.addEventListener('input', timeTool);
    if (fmt) fmt.addEventListener('change', timeTool);

    const insert = $('[data-dcon-time-insert]', root);
    if (insert) {
      insert.addEventListener('click', () => {
        const s = stamp();
        const token = '<t:' + s.unix + ':' + s.f + '>';
        // At the cursor, not appended — the point is usually mid-sentence.
        const at = message.selectionStart != null ? message.selectionStart : message.value.length;
        const to = message.selectionEnd != null ? message.selectionEnd : at;
        message.value = message.value.slice(0, at) + token + message.value.slice(to);
        const pos = at + token.length;
        message.focus();
        message.setSelectionRange(pos, pos);
        preview();
      });
    }
    timeTool();

    const send = $('[data-dcon-send]', root);
    if (send) {
      send.addEventListener('click', async () => {
        const url = read();
        const body = message.value.trim();
        const head = title.value.trim();
        // An embed with neither a title nor a description renders as an empty
        // card, which Discord accepts and nobody wants.
        if (!url || (!body && !head)) return;

        send.disabled = true;
        say(S.discordSending || 'Sending…');

        const embed = { color: hexToInt(colour ? colour.value : root.dataset.color, 6453495) };
        if (head) embed.title = head;
        if (body) embed.description = body;
        if (link.value.trim()) embed.url = link.value.trim();
        if (thumb) embed.thumbnail = { url: thumb };
        if (image && image.value.trim()) embed.image = { url: image.value.trim() };
        if (root.dataset.name) {
          embed.author = { name: root.dataset.name };
          if (root.dataset.avatar) embed.author.icon_url = root.dataset.avatar;
        }
        if (root.dataset.footer) {
          embed.footer = { text: root.dataset.footer };
          if (root.dataset.footerIcon) embed.footer.icon_url = root.dataset.footerIcon;
        }
        if (root.dataset.timestamp === 'true') embed.timestamp = new Date().toISOString();

        const payload = { embeds: [embed] };
        if (root.dataset.name) payload.username = root.dataset.name;
        if (root.dataset.avatar) payload.avatar_url = root.dataset.avatar;

        // Mentions live in the content, and Discord ignores them unless
        // allowed_mentions says so — a webhook will happily post a mention that
        // notifies nobody otherwise. "roles" in parse and a roles list are
        // mutually exclusive, so only the specific ids are listed.
        const chosen = pings();
        if (chosen.length) {
          payload.content = mentionText();
          const ids = chosen.filter((b) => b.dataset.everyone !== 'true').map((b) => b.dataset.roleId);
          payload.allowed_mentions = { parse: [] };
          if (chosen.some((b) => b.dataset.everyone === 'true')) payload.allowed_mentions.parse.push('everyone');
          if (ids.length) payload.allowed_mentions.roles = ids;
        }

        try {
          const res = await fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
          });
          if (res.ok) {
            say(S.discordSent || 'Posted to Discord.');
            title.value = '';
            message.value = '';
            link.value = '';
            if (image) image.value = '';
            thumb = '';
            $$('[data-dcon-template]', root).forEach((b) => b.classList.remove('is-on'));
            $$('[data-dcon-ping]', root).forEach((b) => {
              b.setAttribute('aria-pressed', 'false');
              b.classList.remove('is-on');
            });
            preview();
          } else if (res.status === 401 || res.status === 404) {
            // Usually a webhook that was deleted or regenerated, and leaving a
            // dead one saved would fail the same way forever.
            say(S.discordDead || 'That webhook no longer works. Paste a new one.', true);
            try { localStorage.removeItem(DISCORD_KEY); } catch (e) { /* ignore */ }
            paint();
          } else if (res.status === 429) {
            say(S.discordRate || 'Discord is rate limiting. Wait a moment.', true);
          } else {
            say((S.discordFailed || 'Discord refused it (HTTP [n]).').replace('[n]', res.status), true);
          }
        } catch (e) {
          say(S.discordOffline || 'Could not reach Discord.', true);
        }
        send.disabled = false;
      });
    }

    paint();
  });

  /* ----------------------------------------------------------- staff gate */

  // Only used by the theme-password mode. The customer-tag mode needs no script
  // at all: Shopify decides on its server and Liquid never renders the content.
  //
  // Nothing here is a security boundary and it is not pretending to be. The hash
  // it compares against is in the page, the flag it sets is in sessionStorage,
  // and both are a keystroke away in dev tools. It keeps a dashboard tidy.
  const ADMIN_KEY = 'picovr-staff';

  async function sha256(text) {
    if (!window.crypto || !crypto.subtle) return null;
    const bytes = new TextEncoder().encode(text);
    const digest = await crypto.subtle.digest('SHA-256', bytes);
    return [...new Uint8Array(digest)].map((b) => b.toString(16).padStart(2, '0')).join('');
  }

  function adminSession() {
    try {
      const raw = sessionStorage.getItem(ADMIN_KEY);
      if (!raw) return null;
      const s = JSON.parse(raw);
      // A stored expiry is a courtesy, not a lock — it stops a shared machine
      // staying signed in all week.
      return s && s.until > Date.now() ? s : null;
    } catch (e) {
      return null;
    }
  }

  $$('[data-admin-gate]').forEach((root) => {
    const form = $('[data-admin-form]', root);

    // Setup helper: turns a password into the hash to paste into the editor, so
    // the password itself never has to be written into the theme.
    const make = $('[data-admin-hash]', root);
    if (make) {
      make.addEventListener('click', async () => {
        const value = $('[data-admin-new]', root).value.trim();
        if (!value) return;
        const digest = await sha256(value);
        if (!digest) return;
        $('[data-admin-hash-value]', root).textContent = digest;
        const copy = $('[data-admin-copy]', root);
        if (copy) copy.dataset.copy = digest;
        $('[data-admin-hash-out]', root).hidden = false;
      });
    }

    if (!form) return;

    // Already signed in? Then this page has nothing to ask.
    const live = adminSession();
    if (live) {
      window.location.replace(root.dataset.dashboard || '/pages/dashboard');
      return;
    }

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const err = $('[data-admin-error]', root);
      const user = $('[data-admin-user]', root).value.trim();
      const pass = $('[data-admin-pass]', root).value;
      const digest = await sha256(pass);

      const ok = digest && user === root.dataset.user && digest === root.dataset.hash;
      if (!ok) {
        if (err) err.hidden = false;
        $('[data-admin-pass]', root).value = '';
        return;
      }

      const hours = Math.max(1, Number(root.dataset.hours) || 12);
      try {
        sessionStorage.setItem(ADMIN_KEY, JSON.stringify({
          user: user,
          until: Date.now() + hours * 3600 * 1000,
        }));
      } catch (e) {
        /* private mode; the dashboard will simply ask again */
      }
      window.location.assign(root.dataset.dashboard || '/pages/dashboard');
    });
  });

  $$('[data-admin-dashboard]').forEach((root) => {
    const locked = $('[data-admin-locked]', root);
    const body = $('[data-admin-body]', root);
    const session = adminSession();

    if (!session) {
      if (body) body.hidden = true;
      return;
    }

    if (locked) locked.hidden = true;
    if (body) body.hidden = false;

    const who = $('[data-admin-who]', root);
    if (who) who.textContent = (window.themeStrings.adminSignedIn || 'Signed in as [n]').replace('[n]', session.user);

    const out = $('[data-admin-signout]', root);
    if (out) {
      out.addEventListener('click', () => {
        try { sessionStorage.removeItem(ADMIN_KEY); } catch (e) { /* nothing to clear */ }
        window.location.assign(root.dataset.login || '/pages/admin');
      });
    }
  });

  /* ---------------------------------------------------------- network check */

  $$('[data-network-check]').forEach((root) => {
    const start = $('[data-nc-start]', root);
    const out = $('[data-nc-out]', root);
    const hint = $('[data-nc-hint]', root);
    if (!start || !out) return;

    const S = window.themeStrings || {};
    const endpoint = root.dataset.endpoint;
    const samples = Math.max(4, Number(root.dataset.samples) || 12);
    const speedUrl = root.dataset.speedUrl || '';
    const speedRuns = Math.max(1, Number(root.dataset.speedRuns) || 3);

    const t = {
      goodJ: Number(root.dataset.goodJitter) || 25,
      okJ: Number(root.dataset.okJitter) || 60,
      pct: Number(root.dataset.jitterPct) || 25,
      slow: Number(root.dataset.slowLatency) || 400,
    };

    // One round trip. Timed around the full response, not just the headers, and
    // never from cache — a cached reply would report a latency of nothing.
    async function ping() {
      const url = endpoint + (endpoint.indexOf('?') < 0 ? '?' : '&') + 'nc=' + Math.random();
      const t0 = performance.now();
      try {
        const res = await fetch(url, { cache: 'no-store' });
        await res.arrayBuffer();
        return res.ok ? performance.now() - t0 : null;
      } catch (e) {
        return null;
      }
    }

    // Bytes actually on the wire, not bytes after the browser unpacked them.
    // arrayBuffer().byteLength is the *decompressed* size, so a text file served
    // gzipped would report several times what really crossed the link and the
    // result would be nonsense. Resource Timing knows the encoded size, which is
    // what we want and which makes the file's type stop mattering — any file
    // works, compressible or not.
    //
    // encodedBodySize is only exposed cross-origin when the server sends
    // Timing-Allow-Origin. Shopify's CDN does; if some other host does not, it
    // reads 0 and we fall back to the decompressed size, which is exact for
    // anything already compressed (images, video, zip, a .bin of random bytes).
    function wireBytes(url, fallback) {
      try {
        const abs = new URL(url, location.href).href;
        const hits = performance.getEntriesByName(abs);
        const e = hits[hits.length - 1];
        if (e && e.encodedBodySize > 0) return e.encodedBodySize;
      } catch (err) {
        /* Resource Timing unavailable; fall through */
      }
      return fallback;
    }

    // Best of several runs, because the first is paying for connection ramp-up
    // rather than measuring the link. Reports why it failed as well as whether
    // it did: a file that downloads too fast to time is a sizing problem the
    // merchant can fix, and saying "n/a" would leave them guessing.
    const TOO_SHORT = 0.05;

    async function measureSpeed() {
      let best = 0;
      let got = 0;
      let short = 0;
      for (let n = 0; n < speedRuns; n += 1) {
        const url = speedUrl + (speedUrl.indexOf('?') < 0 ? '?' : '&') + 'nc=' + Math.random();
        const t0 = performance.now();
        try {
          const res = await fetch(url, { cache: 'no-store' });
          const buf = await res.arrayBuffer();
          const secs = (performance.now() - t0) / 1000;
          const bytes = wireBytes(url, buf.byteLength);
          if (bytes <= 0) continue;
          got += 1;
          // Below this the timer noise is bigger than the signal, and the number
          // would be invented rather than measured.
          if (secs < TOO_SHORT) short += 1;
          else best = Math.max(best, (bytes * 8) / secs / 1e6);
        } catch (e) {
          /* one bad run should not sink the measurement */
        }
      }
      return { mbps: best, tooFast: !best && got > 0 && short > 0 };
    }

    function median(xs) {
      const s = xs.slice().sort((a, b) => a - b);
      const m = Math.floor(s.length / 2);
      return s.length % 2 ? s[m] : (s[m - 1] + s[m]) / 2;
    }

    async function run() {
      start.disabled = true;
      start.textContent = S.networkTesting || 'Testing…';
      out.hidden = false;
      if (hint) hint.hidden = true;

      // A warm-up that is thrown away: it pays for the DNS lookup and the TLS
      // handshake, which are not part of what we are trying to measure.
      await ping();

      const times = [];
      let lost = 0;
      for (let n = 0; n < samples; n += 1) {
        const ms = await ping();
        if (ms === null) lost += 1;
        else times.push(ms);
      }

      const latEl = $('[data-nc-latency]', root);
      const jitEl = $('[data-nc-jitter]', root);
      const lostEl = $('[data-nc-lost]', root);
      const dot = $('[data-nc-dot]', root);
      const verdict = $('[data-nc-verdict-text]', root);

      if (!times.length) {
        latEl.textContent = jitEl.textContent = '—';
        lostEl.textContent = lost + '/' + samples;
        dot.dataset.level = 'bad';
        verdict.textContent = S.networkFailed || 'Could not reach the network.';
        start.disabled = false;
        start.textContent = S.networkAgain || 'Test again';
        return;
      }

      const lat = median(times);
      // The middle half of the samples, not the 10th-to-90th band. Over a dozen
      // requests a single hiccup — a garbage collection, a scheduler pause, one
      // cache miss — lands squarely in the 90th percentile and doubles the
      // reading, which is how a steady connection got called unstable. The
      // interquartile range ignores one bad sample at each end, and genuine
      // instability affects far more than one.
      const sorted = times.slice().sort((a, b) => a - b);
      const lo = sorted[Math.floor(sorted.length * 0.25)];
      const hi = sorted[Math.min(sorted.length - 1, Math.floor(sorted.length * 0.75))];
      const jit = hi - lo;

      latEl.textContent = Math.round(lat) + ' ms';
      jitEl.textContent = Math.round(jit) + ' ms';
      lostEl.textContent = lost + '/' + samples;

      // Stability is jitter and loss, not latency. Latency is mostly how far
      // away the server is: a steady connection on the other side of an ocean
      // sits at 200ms and never wavers, while a flaky one next door swings
      // between 20 and 300. Judging on the absolute number called a perfectly
      // stable link unstable, which is what this used to do.
      //
      // The allowance is the larger of a floor and a share of the median, so it
      // scales with distance instead of punishing it.
      const allowGood = Math.max(t.goodJ, lat * (t.pct / 100));
      const allowOk = Math.max(t.okJ, lat * ((t.pct * 2) / 100));

      let level = 'bad';
      let text = S.networkBad || 'Your connection looks unstable.';
      if (!lost && jit <= allowGood) {
        level = 'good';
        text = S.networkGood || 'Your connection looks steady.';
      } else if (lost <= 1 && jit <= allowOk) {
        level = 'ok';
        text = S.networkOk || 'Usable, with some variation.';
      }

      // Being far away is worth mentioning, but it is not instability and does
      // not change the verdict.
      if (level === 'good' && lat > t.slow) {
        text += ' ' + (S.networkFar || 'The round trip is long, which is distance rather than instability.');
      }

      dot.dataset.level = level;
      verdict.textContent = text;

      // What the browser will tell us about the connection, where it does.
      const conn = navigator.connection;
      if (conn && conn.effectiveType && !$('[data-nc-conn]', root)) {
        const stats = $('.nc__stats', root);
        const box = document.createElement('div');
        box.className = 'nc__stat';
        box.setAttribute('data-nc-conn', '');
        const label = document.createElement('span');
        label.className = 'nc__stat-label';
        label.textContent = S.networkReported || 'Reported as';
        const val = document.createElement('strong');
        val.textContent = conn.effectiveType.toUpperCase();
        box.appendChild(label);
        box.appendChild(val);
        stats.appendChild(box);
      }

      if (speedUrl) {
        const speedEl = $('[data-nc-speed]', root);
        if (speedEl) {
          speedEl.textContent = S.networkMeasuring || '…';
          const r = await measureSpeed();
          if (r.mbps) {
            speedEl.textContent =
              (r.mbps >= 10 ? Math.round(r.mbps) : r.mbps.toFixed(1)) + ' Mbps';
          } else {
            speedEl.textContent = r.tooFast
              ? S.networkTooFast || 'File too small'
              : S.networkNoSpeed || 'n/a';
          }
        }
      }

      start.disabled = false;
      start.textContent = S.networkAgain || 'Test again';
    }

    start.addEventListener('click', run);
  });

  /* ------------------------------------------------------------------ rails */

  // One row that scrolls sideways: arrows, edge fades and wheel support.
  // Shared by the category pills and the product carousel.
  $$('[data-rail]').forEach((rail) => {
    const track = $('[data-rail-track]', rail);
    const prev = $('[data-rail-prev]', rail);
    const next = $('[data-rail-next]', rail);
    if (!track) return;

    function sync() {
      const max = track.scrollWidth - track.clientWidth;
      const overflows = max > 1;
      // The track is padded so hover lifts and focus rings are not clipped,
      // and scroll snapping parks the row against the first card's edge —
      // which is that padding, not zero. Measuring from zero left a back
      // arrow showing at rest with nothing behind it.
      const cs = getComputedStyle(track);
      const rest = parseFloat(cs.paddingLeft) || 0;
      const slack = rest + 1;
      const atStart = track.scrollLeft <= slack;
      const atEnd = track.scrollLeft >= max - slack;

      if (prev) prev.hidden = !overflows || atStart;
      if (next) next.hidden = !overflows || atEnd;
      // Each edge only fades while there is more content past it, so a rail
      // that fits reads as plain content rather than something cut off.
      rail.classList.toggle('can-prev', overflows && !atStart);
      rail.classList.toggle('can-next', overflows && !atEnd);
      rail.classList.toggle('is-scrollable', overflows);
    }

    // sync() reads scrollWidth and clientWidth, which forces layout. Running it
    // straight off the scroll event meant a forced layout per event per rail,
    // during the one moment the browser can least afford it — so it is
    // coalesced into the next frame instead.
    let queued = false;
    const syncSoon = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => { queued = false; sync(); });
    };

    const step = () => {
      const item = track.firstElementChild;
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      // Whole cards where the rail holds cards, otherwise most of a screenful.
      if (item && item.offsetWidth) {
        const span = item.offsetWidth + gap;
        return Math.max(1, Math.floor(track.clientWidth / span)) * span;
      }
      return Math.max(160, track.clientWidth * 0.8);
    };

    // No `behavior` here on purpose: the CSS decides, and the CSS turns
    // smoothing off for visitors who prefer reduced motion. Passing 'smooth'
    // would force the animation on them regardless.
    const nudge = (dir) => {
      track.scrollBy({ left: dir * step() });
      // The scroll event is the primary signal, but it can be coalesced or
      // arrive after a smooth scroll settles — re-check once the animation
      // would be over so an arrow never lingers at the end of the rail.
      setTimeout(sync, 400);
    };
    if (prev) prev.addEventListener('click', () => nudge(-1));
    if (next) next.addEventListener('click', () => nudge(1));

    // A vertical wheel over the rail scrolls it sideways, but only while it
    // has somewhere left to go. At either end the page takes the scroll back,
    // so the rail never traps the reader mid-page.
    track.addEventListener(
      'wheel',
      (e) => {
        if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) return; // trackpad, already sideways
        const max = track.scrollWidth - track.clientWidth;
        if (max <= 1) return;
        if (e.deltaY > 0 && track.scrollLeft >= max - 1) return;
        if (e.deltaY < 0 && track.scrollLeft <= 1) return;
        e.preventDefault();
        track.scrollLeft += e.deltaY;
        syncSoon();
      },
      { passive: false }
    );

    track.addEventListener('scroll', syncSoon, { passive: true });
    window.addEventListener('resize', syncSoon);
    if ('ResizeObserver' in window) new ResizeObserver(syncSoon).observe(track);

    // The first measurement happens before the display font has swapped in,
    // which makes the pills briefly wider than they end up — enough to leave
    // a next arrow showing on a row that does not actually overflow.
    window.addEventListener('load', sync, { once: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(sync);

    // The active pill can start off-screen on a narrow window.
    const on = $('.chip.is-on', track);
    if (on && on.offsetLeft > track.clientWidth) {
      track.scrollLeft = on.offsetLeft - track.clientWidth / 2 + on.offsetWidth / 2;
    }
    sync();
  });

  /* ----------------------------------------------------- collection browser */

  $$('[data-collection-browser]').forEach((root) => {
    const chips = $$('[data-chip-filter]', root);
    const items = $$('[data-cbrowse-item]', root);
    const empty = $('[data-cbrowse-empty]', root);
    if (!chips.length || !items.length) return;

    function apply(handle) {
      let shown = 0;
      items.forEach((item) => {
        const list = (item.dataset.collections || '').split(/\s+/);
        const match = !handle || list.indexOf(handle) !== -1;
        item.hidden = !match;
        if (match) shown += 1;
      });

      if (empty) {
        // A category can be real but empty — say so rather than leaving a gap.
        empty.hidden = shown > 0;
        empty.textContent = shown ? '' : root.dataset.empty || '';
      }

      // Hiding cards changes how far the rail can scroll, so the arrows and
      // fades have to be recalculated — and the row rewound, or a filter
      // applied while scrolled along lands on blank space.
      const track = $('[data-rail-track]', root);
      if (track) {
        track.scrollLeft = 0;
        window.dispatchEvent(new Event('resize'));
      }
    }

    chips.forEach((chip) => {
      chip.addEventListener('click', () => {
        chips.forEach((c) => {
          const on = c === chip;
          c.classList.toggle('is-on', on);
          c.setAttribute('aria-pressed', String(on));
        });
        apply(chip.dataset.chipFilter);
      });
    });

    apply('');
  });

  /* -------------------------------------------------------- mounting helper */

  $$('[data-mounting-helper]').forEach((root) => {
    const tabs = $$('[data-mh-tab]', root);
    const panels = $$('[data-mh-panel]', root);
    if (!tabs.length) return;

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        tabs.forEach((t) => {
          const on = t === tab;
          t.classList.toggle('is-on', on);
          t.setAttribute('aria-selected', String(on));
        });
        panels.forEach((p) => {
          p.hidden = p.dataset.mhPanel !== tab.dataset.mhTab;
        });
      });
    });
  });

  /* ------------------------------------------------------------ strap guide */

  $$('[data-strap-guide]').forEach((root) => {
    const setSel = $('[data-sg-set]', root);
    const totalsEl = $('[data-sg-totals]', root);
    const rowsEl = $('[data-sg-rows]', root);
    const warn = $('[data-sg-warn]', root);
    const measures = $$('[data-sg-measure]', root);

    let straps;
    let spots;
    try {
      straps = JSON.parse($('[data-sg-straps]', root).textContent);
      spots = JSON.parse($('[data-sg-spots]', root).textContent);
    } catch (e) {
      return;
    }
    if (!straps.length || !spots.length) return;

    // Shortest first, so the first strap that fits is the one to use.
    straps.sort((a, b) => a.cm - b.cm);

    const strings = (window.themeStrings && window.themeStrings.strap) || {};
    const IN = 2.54;
    let unit = 'cm';

    const round = (n) => Math.round(n * 10) / 10;

    function pick(cm) {
      // First strap long enough to go round. `min` only decides which strap
      // gets suggested when several fit, not whether one is possible.
      const fits = straps.filter((s) => cm <= s.max);
      if (!fits.length) return null;
      const proper = fits.find((s) => cm >= s.min);
      return proper || fits[0];
    }

    function render() {
      const count = Number(setSel ? setSel.value : 0);
      const needed = spots.filter((s) => s.from <= count);
      const totals = new Map();
      const rows = [];
      let unmatched = 0;

      needed.forEach((spot) => {
        if (!spot.measure) {
          rows.push({ label: spot.label, qty: spot.qty, around: null, strap: null, note: spot.note });
          return;
        }
        const input = measures.find((m) => m.dataset.sgMeasure === spot.measure);
        const cm = input ? Number(input.dataset.cm) : NaN;
        const strap = isFinite(cm) && cm > 0 ? pick(cm) : null;
        if (!strap) unmatched += 1;
        if (strap) totals.set(strap.label, (totals.get(strap.label) || 0) + spot.qty);
        rows.push({ label: spot.label, qty: spot.qty, around: cm, strap: strap, note: spot.note });
      });

      totalsEl.innerHTML = '';
      straps.forEach((s) => {
        const n = totals.get(s.label) || 0;
        if (!n) return;
        const el = document.createElement('div');
        el.className = 'sg__total';
        el.innerHTML =
          '<strong>' + n + ' &times;</strong><span>' + s.label + '</span>' +
          (s.note ? '<em>' + s.note + '</em>' : '');
        // Built as a node rather than more innerHTML: the href is merchant text
        // and setting it as a property keeps it a URL rather than markup.
        if (s.link) {
          const buy = document.createElement('a');
          buy.className = 'btn btn--solid btn--sm sg__buy';
          buy.href = s.link;
          buy.textContent = (s.cta || 'Get this strap') + (s.price ? ' — ' + s.price : '');
          el.appendChild(buy);
        }
        totalsEl.appendChild(el);
      });

      rowsEl.innerHTML = '';
      rows.forEach((r) => {
        const tr = document.createElement('tr');
        const name = document.createElement('th');
        name.setAttribute('scope', 'row');
        name.textContent = r.label + (r.qty > 1 ? ' ×' + r.qty : '');
        const around = document.createElement('td');
        around.textContent = r.around
          ? (unit === 'in' ? round(r.around / IN) + ' in' : round(r.around) + ' cm')
          : '—';
        const strap = document.createElement('td');
        if (r.strap) {
          strap.textContent = r.strap.label;
        } else if (r.around) {
          // Measured, but nothing we sell goes round it. Saying "no strap
          // needed" here would be telling them the opposite of the truth.
          strap.textContent = strings.toolong || 'Ask us';
          strap.className = 'sg__over';
        } else {
          strap.textContent = r.note || strings.none || 'No strap needed';
          strap.className = 'sg__none';
        }
        tr.append(name, around, strap);
        rowsEl.appendChild(tr);
      });

      if (warn) {
        // Only fires when something is genuinely bigger than the longest
        // strap — better to say so than to quietly recommend one that will
        // not close.
        warn.hidden = unmatched === 0;
        warn.textContent = unmatched
          ? (strings.toobig || 'One measurement is larger than our longest strap — get in touch and we will sort something out.')
          : '';
      }
    }

    measures.forEach((input) => {
      input.addEventListener('input', () => {
        const raw = Number(input.value);
        input.dataset.cm = isFinite(raw) && raw > 0 ? (unit === 'in' ? raw * IN : raw) : '';
        render();
      });
    });

    if (setSel) setSel.addEventListener('change', render);

    $$('[data-sg-unit]', root).forEach((btn) => {
      btn.addEventListener('click', () => {
        const next = btn.dataset.sgUnit;
        if (next === unit) return;
        unit = next;

        $$('[data-sg-unit]', root).forEach((b) => {
          const on = b === btn;
          b.classList.toggle('is-on', on);
          b.setAttribute('aria-pressed', String(on));
        });
        // The stored value stays in cm; only what is displayed converts.
        measures.forEach((input) => {
          const cm = Number(input.dataset.cm);
          if (!isFinite(cm) || !cm) return;
          input.value = unit === 'in' ? round(cm / IN) : round(cm);
        });
        $$('[data-sg-unit-label]', root).forEach((el) => { el.textContent = unit; });
        render();
      });
    });

    render();
  });

  /* ------------------------------------------------------- game marquee */

  $$('[data-gmarquee-track]').forEach((track) => {
    const marquee = track.parentElement;

    function fill() {
      const groups = $$('[data-gmarquee-group]', track);
      const first = groups[0];
      if (!first) return;

      const groupWidth = first.getBoundingClientRect().width;
      if (!groupWidth) return;

      // The row must stay covered at every point in the cycle, which needs
      // the track to span at least one viewport beyond the shift distance.
      const needed = Math.max(2, Math.ceil(marquee.clientWidth / groupWidth) + 1);

      for (let i = groups.length; i < needed; i++) {
        const clone = first.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        // Clones must not duplicate ids or editor bindings.
        $$('[id]', clone).forEach((el) => el.removeAttribute('id'));
        track.appendChild(clone);
      }

      track.style.setProperty('--gm-shift', groupWidth + 'px');
    }

    fill();

    // Card widths are viewport-relative, so a resize changes the shift.
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(fill, 200);
    });

    // Cover art arriving late changes the group width.
    $$('img', track).forEach((img) => {
      if (!img.complete) img.addEventListener('load', fill, { once: true });
    });
  });

  /* --------------------------------------------------------------- blobs */

  const blobLayer = $('.bg-blobs');

  if (blobLayer) {
    const blobs = $$('.bg-blob', blobLayer);
    const styles = getComputedStyle(document.documentElement);
    const palette = [
      styles.getPropertyValue('--accent-a').trim() || '#ff0022',
      styles.getPropertyValue('--accent-b').trim() || '#627af7'
    ];

    const rand = (min, max) => min + Math.random() * (max - min);

    // Higher setting = faster, so it divides the duration.
    const speed = Math.max(25, Number(blobLayer.dataset.blobSpeed) || 100) / 100;

    // Each blob gets its own band of the viewport rather than a free-for-all,
    // so a reshuffle never clusters them all in one corner or leaves a
    // quadrant empty.
    const bands = [
      { x: [-20, 15], y: [-20, 15] },
      { x: [55, 90], y: [-10, 25] },
      { x: [-10, 30], y: [40, 70] },
      { x: [50, 85], y: [55, 90] },
      { x: [20, 60], y: [20, 60] }
    ];

    /* Every blob is a large gradient that animates for the life of the page,
       and a fixed backdrop-filtered header sits over them — so whatever moves
       here is re-blurred continuously on every page of the site.

       At full size that is roughly one and a half viewports of permanently
       animating pixels. A phone has the least headroom for that and is also
       where the composition reads least: at 375px wide you see a wash of
       colour, not five distinct shapes. So small screens get fewer and
       smaller, which is invisible there and is the single biggest saving
       available without changing how the site looks. */
    const narrow = window.matchMedia('(max-width: 48em)').matches;
    const maxBlobs = narrow ? 3 : blobs.length;
    const sizeRange = narrow ? [34, 52] : [42, 72];

    blobs.forEach((blob, i) => {
      if (i >= maxBlobs) {
        blob.hidden = true;
        return;
      }
      const band = bands[i % bands.length];
      const s = blob.style;
      s.setProperty('--bx', rand(band.x[0], band.x[1]).toFixed(1) + '%');
      s.setProperty('--by', rand(band.y[0], band.y[1]).toFixed(1) + '%');
      s.setProperty('--bs', rand(sizeRange[0], sizeRange[1]).toFixed(1) + 'vw');
      s.setProperty('--bc', palette[i % palette.length]);
      s.setProperty('--bo', rand(0.1, 0.24).toFixed(3));
      // Two offset lobes per blob, reshuffled every load. This is what makes
      // the shapes irregular rather than perfect circles — what a heavy blur
      // over overlapping discs used to do, minus the filter pass.
      //
      // A lobe must finish fading before it reaches the element's edge: a
      // background is clipped by its box, so a radius that reaches the edge
      // leaves a flat cut instead of a soft falloff. Hence the radius is
      // capped by how far the lobe sits from the nearest edge.
      const lobe = (px, py, xVar, yVar, rVar, r2Var) => {
        // Each axis is capped by its own room. Capping once and then scaling
        // the vertical radius put it back over the edge on some reloads.
        const acrossRoom = Math.min(px, 100 - px) - 2;
        const downRoom = Math.min(py, 100 - py) - 2;
        const across = Math.min(rand(34, 48), acrossRoom);
        const down = Math.min(across * rand(0.82, 1.18), downRoom);
        s.setProperty(xVar, px.toFixed(0) + '%');
        s.setProperty(yVar, py.toFixed(0) + '%');
        s.setProperty(rVar, across.toFixed(0) + '%');
        s.setProperty(r2Var, down.toFixed(0) + '%');
      };
      lobe(rand(40, 50), rand(40, 50), '--l1x', '--l1y', '--l1r', '--l1r2');
      lobe(rand(50, 60), rand(50, 60), '--l2x', '--l2y', '--l2r', '--l2r2');
      // Mismatched durations keep the group from ever syncing up and pulsing
      // in unison. These are deliberately much shorter than they first were:
      // spread over a minute the drift worked out at ~3px/s, which against a
      // 90px blur is invisible. This lands around 12-25px/s — still calm, but
      // you can actually see it.
      const dur = rand(12, 22) / speed;
      s.setProperty('--bd', dur.toFixed(1) + 's');
      s.setProperty('--bd2', (-rand(0, dur)).toFixed(1) + 's');
      // Pick a direction, then a magnitude that never lands near zero — a
      // range spanning zero occasionally produced a blob that sat still.
      const sign = () => (Math.random() < 0.5 ? -1 : 1);
      s.setProperty('--btx', (sign() * rand(14, 26)).toFixed(1) + 'vw');
      s.setProperty('--bty', (sign() * rand(10, 20)).toFixed(1) + 'vh');
    });
  }

  /* -------------------------------------------------------------- banner */

  const banner = $('[data-banner]');

  if (banner) {
    const key = 'picovr:banner:' + banner.dataset.bannerKey;

    // --banner-h drives every top offset on the page, so clearing it is what
    // actually reclaims the space rather than just hiding the element.
    const collapse = () => {
      banner.hidden = true;
      document.documentElement.style.setProperty('--banner-h', '0rem');
    };

    let dismissed = false;
    try { dismissed = localStorage.getItem(key) === '1'; } catch (e) { /* private mode */ }

    if (dismissed) collapse();

    const closeBtn = $('[data-banner-dismiss]', banner);
    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        collapse();
        try { localStorage.setItem(key, '1'); } catch (e) { /* non-fatal */ }
      });
    }
  }

  /* ---------------------------------------------------------- cart drawer */

  const drawer = $('[data-cart-drawer]');
  const overlay = $('[data-cart-overlay]');

  function openCart() {
    if (!drawer) return;
    drawer.dataset.open = 'true';
    if (overlay) overlay.dataset.open = 'true';
    document.body.style.overflow = 'hidden';
    const close = $('[data-cart-close]', drawer);
    if (close) close.focus();
  }

  function closeCart() {
    if (!drawer) return;
    drawer.dataset.open = 'false';
    if (overlay) overlay.dataset.open = 'false';
    document.body.style.overflow = '';
  }

  $$('[data-cart-open]').forEach((el) => el.addEventListener('click', openCart));
  $$('[data-cart-close]').forEach((el) => el.addEventListener('click', closeCart));
  if (overlay) overlay.addEventListener('click', closeCart);

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    closeCart();
    if (mobileNav && mobileNav.dataset.open === 'true') {
      mobileNav.dataset.open = 'false';
      if (menuToggle) menuToggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }
  });

  async function refreshCart() {
    const res = await fetch(`${window.routes.cart_url}?section_id=cart-drawer-items`);
    const count = await fetch(`${window.routes.cart_url}.js`).then((r) => r.json());

    const badge = $('[data-cart-count]');
    if (badge) {
      badge.textContent = count.item_count;
      badge.hidden = count.item_count === 0;
    }

    const total = $('[data-cart-total]');
    if (total) total.textContent = formatMoney(count.total_price);

    const foot = $('[data-cart-foot]');
    if (foot) foot.hidden = count.item_count === 0;

    const body = $('[data-cart-body]');
    if (body && res.ok) {
      const html = await res.text();
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const fresh = parsed.querySelector('[data-cart-body]') || parsed.body.firstElementChild;
      if (fresh) body.innerHTML = fresh.innerHTML;
      bindLineRemovers();
    }
  }

  async function changeLine(line, quantity) {
    await fetch(window.routes.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity })
    });
    await refreshCart();
  }

  function bindLineRemovers() {
    $$('[data-line-remove]').forEach((btn) => {
      btn.addEventListener('click', () => changeLine(btn.dataset.line, 0));
    });
  }

  bindLineRemovers();

  /* -------------------------------------------------------------- product */

  const productRoot = $('[data-product-root]');

  if (productRoot) {
    const variantData = JSON.parse($('[data-variant-json]', productRoot).textContent);
    const variantInput = $('[data-variant-id]', productRoot);
    const addBtn = $('[data-add-to-cart]', productRoot);
    const priceTarget = $('[data-price-target]', productRoot);
    const mainImage = $('[data-product-image]', productRoot);

    function selectedOptions() {
      const groups = {};
      $$('[data-option-value][aria-checked="true"]', productRoot).forEach((btn) => {
        groups[btn.dataset.optionIndex] = btn.dataset.value;
      });
      return Object.keys(groups)
        .sort((a, b) => Number(a) - Number(b))
        .map((k) => groups[k]);
    }

    function updateVariant() {
      const chosen = selectedOptions();
      const match = variantData.find((v) =>
        v.options.every((opt, i) => opt === chosen[i])
      );

      if (!match) {
        addBtn.disabled = true;
        addBtn.textContent = window.themeStrings.unavailable;
        return;
      }

      variantInput.value = match.id;
      addBtn.disabled = !match.available;
      addBtn.textContent = match.available
        ? window.themeStrings.addToCart
        : window.themeStrings.soldOut;

      if (priceTarget) {
        const onSale = match.compare_at_price && match.compare_at_price > match.price;
        priceTarget.innerHTML =
          `<div class="price${onSale ? ' price--on-sale' : ''}">` +
          `<span class="price__current">${formatMoney(match.price)}</span>` +
          (onSale ? `<s class="price__compare">${formatMoney(match.compare_at_price)}</s>` : '') +
          '</div>';
      }

      if (match.featured_image && mainImage) {
        mainImage.src = match.featured_image.src;
      }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url);
    }

    $$('[data-option-value]', productRoot).forEach((btn) => {
      btn.addEventListener('click', () => {
        $$(`[data-option-value][data-option-index="${btn.dataset.optionIndex}"]`, productRoot)
          .forEach((sibling) => sibling.setAttribute('aria-checked', 'false'));
        btn.setAttribute('aria-checked', 'true');
        updateVariant();
      });
    });

    const qtyInput = $('[data-qty-input]', productRoot);
    const down = $('[data-qty-down]', productRoot);
    const up = $('[data-qty-up]', productRoot);
    if (down) down.addEventListener('click', () => {
      qtyInput.value = Math.max(1, Number(qtyInput.value) - 1);
    });
    if (up) up.addEventListener('click', () => {
      qtyInput.value = Number(qtyInput.value) + 1;
    });

    $$('[data-thumb]', productRoot).forEach((thumb) => {
      thumb.addEventListener('click', () => {
        $$('[data-thumb]', productRoot).forEach((t) => t.setAttribute('aria-current', 'false'));
        thumb.setAttribute('aria-current', 'true');
        if (mainImage) mainImage.src = thumb.dataset.full;
      });
    });

    const form = $('#product-form', productRoot);
    if (form) {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        addBtn.disabled = true;

        const res = await fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: { Accept: 'application/javascript' },
          body: new FormData(form)
        });

        addBtn.disabled = false;

        if (!res.ok) {
          addBtn.textContent = window.themeStrings.cartError;
          return;
        }

        await refreshCart();
        openCart();
      });
    }
  }

  /* ------------------------------------------------------- hero carousel */

  const carousel = $('[data-hero-carousel]');

  if (carousel) {
    const slides = $$('[data-hero-slide]', carousel);
    const dots = $$('[data-hero-dot]');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const mobile = window.matchMedia('(max-width: 47.99em)').matches;
    // Respect an explicit request to save data, and treat 2g as that too. The
    // hero is four clips; on a metered connection that is megabytes for
    // decoration, and the posters carry the same picture.
    const conn = navigator.connection || {};
    const thrifty = conn.saveData === true || /(^|-)2g$/.test(conn.effectiveType || '');
    const allowVideo =
      !reduceMotion && !thrifty && (!mobile || carousel.dataset.autoplayMobile === 'true');

    let index = 0;
    let timer = null;
    const STILL_MS = 6000;

    const videoAt = (i) => slides[i] && slides[i].querySelector('[data-hero-video]');

    function show(i) {
      if (!slides.length) return;
      index = ((i % slides.length) + slides.length) % slides.length;

      slides.forEach((s, n) => s.classList.toggle('is-active', n === index));
      dots.forEach((d, n) => d.setAttribute('aria-current', String(n === index)));

      clearTimeout(timer);

      const video = videoAt(index);

      if (video && allowVideo) {
        // Warm the next clip so the crossfade isn't a black gap — but only once
        // this one is actually playing. Warming it up front meant the two
        // competed for bandwidth on load, which is the worst moment for it.
        const warmNext = () => {
          const next = videoAt((index + 1) % slides.length);
          if (next && next.preload === 'none') next.preload = 'auto';
        };
        video.addEventListener('playing', warmNext, { once: true });

        video.currentTime = 0;
        const played = video.play();
        if (played && played.catch) {
          // Autoplay can still be refused; fall through to the timer.
          played.catch(() => { timer = setTimeout(advance, STILL_MS); });
        }
      } else {
        timer = setTimeout(advance, STILL_MS);
      }
    }

    function advance() { show(index + 1); }

    if (slides.length > 1) {
      slides.forEach((slide, i) => {
        const video = slide.querySelector('[data-hero-video]');
        if (!video) return;
        video.addEventListener('ended', () => { if (i === index) advance(); });
        // A clip that fails to load must not stall the whole carousel.
        video.addEventListener('error', () => { if (i === index) advance(); });
      });

      dots.forEach((dot) =>
        dot.addEventListener('click', () => show(Number(dot.dataset.index)))
      );

      // Pause work while the hero is off screen.
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const video = videoAt(index);
              if (entry.isIntersecting) {
                if (video && allowVideo) video.play().catch(() => {});
                else if (!timer) timer = setTimeout(advance, STILL_MS);
              } else {
                if (video) video.pause();
                clearTimeout(timer);
                timer = null;
              }
            });
          },
          { threshold: 0.15 }
        ).observe(carousel);
      }

      show(0);
    } else {
      const only = videoAt(0);
      if (only && allowVideo) only.play().catch(() => {});
    }
  }

  /* ------------------------------------------------- how it works player */

  $$('[data-hiw]').forEach((root) => {
    const scenes = $$('[data-hiw-scene]', root);
    const caps = $$('[data-hiw-cap]', root);
    const segs = $$('[data-hiw-seg]', root);
    const track = $('[data-hiw-track]', root);
    const toggle = $('[data-hiw-toggle]', root);
    const replay = $('[data-hiw-replay]', root);
    const sound = $('[data-hiw-sound]', root);
    const audio = $('[data-hiw-audio]', root);
    if (!scenes.length) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const loop = root.dataset.loop === 'true';
    const stretch = root.dataset.stretch === 'true';

    // Cumulative timeline, in seconds, from the per-step durations.
    const durs = scenes.map((s) => Math.max(1, Number(s.dataset.dur) || 7));
    const total = durs.reduce((a, b) => a + b, 0);
    const starts = [];
    durs.reduce((acc, d, i) => { starts[i] = acc; return acc + d; }, 0);

    let t = 0;
    let index = -1;
    let playing = false;
    let raf = 0;
    let last = 0;
    let onScreen = true;
    let wanted = false; // what the visitor last asked for, so scrolling away can restore it

    // With narration, the audio is the clock and the steps are scaled to fit it,
    // so a recorded voice-over lands on the step it is talking about.
    const rate = () => {
      if (!audio || !stretch) return 1;
      const d = audio.duration;
      return d && isFinite(d) && d > 0 ? total / d : 1;
    };

    const indexAt = (time) => {
      for (let i = durs.length - 1; i >= 0; i -= 1) if (time >= starts[i]) return i;
      return 0;
    };

    function paint() {
      const i = indexAt(t);

      // Only touch the DOM when the step actually changes; the fill below is a
      // custom property, which composites without laying anything out.
      if (i !== index) {
        index = i;
        scenes.forEach((s, n) => s.classList.toggle('is-live', n === i));
        caps.forEach((c, n) => c.classList.toggle('is-live', n === i));
        segs.forEach((s, n) => {
          const on = Number(s.dataset.index) === i;
          s.classList.toggle('is-on', on);
          if (s.classList.contains('hiw__chapter')) s.setAttribute('aria-current', String(on));
        });
      }

      // One value for the whole bar: the gradient spans the track and CSS clips
      // it, so this is a single property write per frame rather than one per
      // step, and the colour ramp runs end to end instead of per segment.
      if (track) track.style.setProperty('--pt', (t / total).toFixed(4));
    }

    function frame(now) {
      if (!playing) return;
      if (audio && !audio.paused && !audio.ended) {
        t = audio.currentTime * rate();
      } else {
        t += (now - last) / 1000;
      }
      last = now;

      if (t >= total) {
        if (loop) {
          t = 0;
          if (audio && !audio.paused) audio.currentTime = 0;
        } else {
          t = total;
          paint();
          pause();
          return;
        }
      }

      paint();
      raf = requestAnimationFrame(frame);
    }

    function play(gesture) {
      if (gesture) wanted = true;
      if (playing || !onScreen) return;
      playing = true;
      root.dataset.playing = 'true';
      if (toggle) toggle.setAttribute('aria-label', root.dataset.labelPause || 'Pause');
      // Sound only ever starts from a real click — browsers refuse it otherwise,
      // and an autoplaying explainer that talks at you is worse than a silent one.
      if (audio && root.dataset.sound === 'true') {
        audio.currentTime = t / rate();
        audio.play().catch(() => {});
      }
      last = performance.now();
      raf = requestAnimationFrame(frame);
    }

    function pause(gesture) {
      if (gesture) wanted = false;
      playing = false;
      root.dataset.playing = 'false';
      if (toggle) toggle.setAttribute('aria-label', root.dataset.labelPlay || 'Play');
      cancelAnimationFrame(raf);
      if (audio) audio.pause();
    }

    function seek(i, gesture) {
      t = starts[i] || 0;
      if (audio) audio.currentTime = t / rate();
      paint();
      if (gesture) play(true);
    }

    if (toggle) {
      toggle.addEventListener('click', () => {
        if (playing) pause(true);
        else play(true);
      });
    }

    if (replay) replay.addEventListener('click', () => seek(0, true));

    segs.forEach((seg) =>
      seg.addEventListener('click', () => seek(Number(seg.dataset.index) || 0, true))
    );

    if (sound && audio) {
      sound.addEventListener('click', () => {
        const on = root.dataset.sound !== 'true';
        root.dataset.sound = String(on);
        sound.setAttribute('aria-pressed', String(on));
        sound.setAttribute(
          'aria-label',
          on ? root.dataset.labelSoundOff || 'Sound off' : root.dataset.labelSoundOn || 'Sound on'
        );
        if (!on) {
          audio.pause();
          return;
        }
        // Turning sound on is the gesture, so start both from here.
        audio.currentTime = t / rate();
        if (playing) audio.play().catch(() => {});
        else play(true);
      });
      // A track whose length only arrives with the metadata changes the scaling.
      audio.addEventListener('loadedmetadata', paint);
      audio.addEventListener('ended', () => {
        if (!loop) pause();
      });
    }

    // Nothing runs while the player is off screen or the tab is in the
    // background, and whatever the visitor asked for is restored on return.
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            onScreen = entry.isIntersecting;
            if (!onScreen) {
              const keep = wanted;
              pause();
              wanted = keep;
            } else if (wanted) {
              play();
            }
          });
        },
        { threshold: 0.25 }
      ).observe(root);
    }

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        const keep = wanted;
        pause();
        wanted = keep;
      } else if (wanted && onScreen) {
        play();
      }
    });

    root.dataset.playing = 'false';
    root.dataset.sound = 'false';
    paint();

    if (root.dataset.autoplay === 'true' && !reduceMotion) {
      wanted = true;
      // The observer starts it when it scrolls in; if it is already in view on
      // load there is no entry to wait for, so nudge it.
      if (!('IntersectionObserver' in window)) play();
    }
  });

  /* ------------------------------------------------------------------ faq */

  $$('[data-faq-trigger]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const item = btn.closest('[data-faq-item]');
      const open = item.dataset.open === 'true';
      item.dataset.open = String(!open);
      btn.setAttribute('aria-expanded', String(!open));
    });
  });

  /* -------------------------------------------------------------- reviews */

  $$('[data-reviews]').forEach((root) => {
    const cards = $$('[data-review]', root);
    const perPage = Math.max(1, Number(root.dataset.perPage) || 6);
    const pages = Math.ceil(cards.length / perPage);
    const pager = $('[data-reviews-pager]', root);
    if (!pager || pages < 2) return;

    const dotsWrap = $('[data-reviews-dots]', root);
    const prev = $('[data-reviews-prev]', root);
    const next = $('[data-reviews-next]', root);
    const label = root.dataset.pageLabel || 'Page [n]';
    let page = 0;

    const dots = [];
    for (let i = 0; i < pages; i += 1) {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'rpager__dot';
      dot.setAttribute('aria-label', label.replace('[n]', i + 1));
      dot.addEventListener('click', () => show(i));
      dotsWrap.appendChild(dot);
      dots.push(dot);
    }

    function show(n) {
      page = (n + pages) % pages;
      cards.forEach((card, i) => {
        card.hidden = Math.floor(i / perPage) !== page;
      });
      dots.forEach((d, i) => {
        d.classList.toggle('is-on', i === page);
        d.setAttribute('aria-current', i === page ? 'true' : 'false');
      });
    }

    if (prev) prev.addEventListener('click', () => show(page - 1));
    if (next) next.addEventListener('click', () => show(page + 1));

    pager.hidden = false;
    show(0);
  });

  /* -------------------------------------------------- discord capture */

  $$('[data-discord-capture]').forEach((box) => {
    const input = $('[data-discord-input]', box);
    const hint = $('[data-discord-hint]', box);
    const skip = $('[data-discord-skip]', box);
    const gate = box.dataset.required === 'true';
    const inDrawer = box.dataset.context === 'drawer';
    if (!input) return;

    /* The checkout control this box guards: the submit button on the cart
       page, the link in the drawer. */
    const root = inDrawer ? box.closest('[data-cart-foot]') || document : box.closest('form') || document;
    const checkout = $('[data-checkout]', root);

    /* Current rules are 2-32 of lowercase letters, digits, underscore and
       full stop. Older accounts still carry name#1234, and plenty of people
       will type an @ or paste with capitals, so all of that is accepted and
       tidied rather than rejected — this is a nice-to-have field, and being
       strict about it would cost an order to save a lookup. */
    const LOOKS_RIGHT = /^@?[a-z0-9._]{2,32}(#\d{4})?$/i;

    const value = () => input.value.trim().replace(/^@+/, '');
    const filled = () => value().length > 0;
    const valid = () => LOOKS_RIGHT.test(value());

    let skipped = false;

    function setCheckout(on) {
      if (!checkout || !gate) return;
      if (checkout.tagName === 'A') {
        /* A disabled attribute means nothing on a link, so it is taken out
           of the tab order and its click is refused below. */
        checkout.classList.toggle('is-disabled', !on);
        checkout.setAttribute('aria-disabled', String(!on));
        if (on) checkout.removeAttribute('tabindex');
        else checkout.setAttribute('tabindex', '-1');
      } else {
        checkout.disabled = !on;
      }
    }

    function sync() {
      const ok = skipped || filled();
      setCheckout(ok);

      if (filled() && !valid()) {
        hint.textContent =
          (window.themeStrings || {}).discordHintFormat ||
          'That does not look like a Discord username.';
        hint.hidden = false;
        box.dataset.state = 'warn';
      } else if (filled()) {
        hint.hidden = true;
        box.dataset.state = 'ok';
      } else {
        hint.hidden = true;
        box.dataset.state = '';
      }
    }

    input.addEventListener('input', sync);
    input.addEventListener('blur', () => {
      /* Tidy on the way out rather than while they type, which would fight
         the cursor. */
      const v = value();
      if (v && v !== input.value) input.value = v;
      sync();
    });

    if (skip) {
      skip.addEventListener('click', () => {
        skipped = true;
        input.value = '';
        sync();
        if (checkout) checkout.focus();
      });
    }

    /* The drawer is not inside a form, so nothing would be posted. Save it
       first, then follow the link — and go anyway if the save fails, since
       losing a checkout over an optional field would be a bad trade. */
    if (inDrawer && checkout) {
      checkout.addEventListener('click', async (e) => {
        if (checkout.getAttribute('aria-disabled') === 'true') {
          e.preventDefault();
          input.focus();
          return;
        }
        if (!filled()) return;

        e.preventDefault();
        const body = { attributes: {} };
        body.attributes[box.dataset.field] = value();
        try {
          await fetch(window.routes.cart_update_url || '/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body),
          });
        } catch (err) {
          /* Ignored on purpose — see above. */
        }
        window.location.href = checkout.href;
      });
    }

    sync();
  });

  /* ------------------------------------------------------ background poster */

  /* Draws the site background at print size. Not a screenshot of the live one:
     a letter page at 300dpi is 2550 x 3300, and the CSS version only ever
     exists at whatever size the window happens to be. */
  $$('[data-poster]').forEach((root) => {
    const canvas = $('[data-poster-canvas]', root);
    if (!canvas) return;

    const el = (sel) => $('[data-poster-' + sel + ']', root);
    const sizeSel = el('size');
    const custom = el('custom');

    /* Seeded so a composition can be returned to. A run of Math.random() is
       gone the moment it is redrawn, which is no use when the whole job is
       trying arrangements until one looks right. */
    function rng(seed) {
      let a = seed >>> 0;
      return () => {
        a += 0x6d2b79f5;
        let t = a;
        t = Math.imul(t ^ (t >>> 15), t | 1);
        t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
        return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
      };
    }

    function brand() {
      const cs = getComputedStyle(document.documentElement);
      return [
        cs.getPropertyValue('--accent-a').trim() || '#ff0022',
        cs.getPropertyValue('--accent-b').trim() || '#627af7',
      ];
    }

    function paper() {
      let w, h;
      if (sizeSel.value === 'custom') {
        w = parseFloat(el('w').value) || 8.5;
        h = parseFloat(el('h').value) || 11;
      } else {
        const parts = sizeSel.value.split('x');
        w = parseFloat(parts[0]);
        h = parseFloat(parts[1]);
      }
      if (el('orient').value === 'landscape') {
        const t = w;
        w = h;
        h = t;
      }
      /* Printers cannot reach the paper edge, so anything meant to bleed has
         to be drawn bigger than the page and trimmed. An eighth of an inch on
         each side is the usual allowance. */
      if (el('bleed').checked) {
        w += 0.25;
        h += 0.25;
      }
      return { w: w, h: h, dpi: parseInt(el('dpi').value, 10) || 300 };
    }

    /* One blob: three offset lobes rather than a single disc, the same shape
       the site uses — a plain blurred circle has a hard middle and reads
       wrong where several overlap. */
    function blob(ctx, x, y, r, colour, alpha, soft) {
      const lobes = [
        [x - r * 0.06, y - r * 0.08, r * 0.68],
        [x + r * 0.06, y + r * 0.08, r * 0.66],
        [x, y, r],
      ];
      lobes.forEach((l, i) => {
        const rad = l[2] * soft;
        const g = ctx.createRadialGradient(l[0], l[1], 0, l[0], l[1], rad);
        g.addColorStop(0, colour);
        g.addColorStop(0.46, colour);
        g.addColorStop(1, colour);
        ctx.save();
        ctx.globalAlpha = alpha * (i === 2 ? 0.5 : 1);
        ctx.globalCompositeOperation = 'lighter';
        /* The fade is done with an alpha ramp rather than colour stops so the
           colour itself never shifts as it thins out — colour-stop fading to
           transparent goes grey in the middle in some browsers. */
        const fade = ctx.createRadialGradient(l[0], l[1], 0, l[0], l[1], rad);
        fade.addColorStop(0, colour);
        fade.addColorStop(0.45, colour);
        fade.addColorStop(1, 'rgba(0,0,0,0)');
        ctx.fillStyle = fade;
        ctx.beginPath();
        ctx.arc(l[0], l[1], rad, 0, Math.PI * 2);
        ctx.fill();
        ctx.restore();
      });
    }

    function grain(ctx, w, h, amount) {
      if (amount <= 0) return;
      /* Drawn small and stretched: a full-resolution noise field at 300dpi is
         millions of random calls and seconds of waiting for something nobody
         can see the individual pixels of anyway. */
      const s = 256;
      const off = document.createElement('canvas');
      off.width = s;
      off.height = s;
      const octx = off.getContext('2d');
      const img = octx.createImageData(s, s);
      for (let i = 0; i < img.data.length; i += 4) {
        const v = 120 + Math.random() * 135;
        img.data[i] = img.data[i + 1] = img.data[i + 2] = v;
        img.data[i + 3] = 255;
      }
      octx.putImageData(img, 0, 0);
      ctx.save();
      ctx.globalAlpha = amount / 100;
      ctx.globalCompositeOperation = 'overlay';
      const step = Math.max(w, h) / 3;
      for (let y = 0; y < h; y += step) {
        for (let x = 0; x < w; x += step) ctx.drawImage(off, x, y, step, step);
      }
      ctx.restore();
    }

    function render() {
      const p = paper();
      const w = Math.round(p.w * p.dpi);
      const h = Math.round(p.h * p.dpi);
      canvas.width = w;
      canvas.height = h;

      const ctx = canvas.getContext('2d');
      const transparent = el('transparent').checked;
      ctx.clearRect(0, 0, w, h);
      if (!transparent) {
        const cs = getComputedStyle(document.documentElement);
        ctx.fillStyle = cs.getPropertyValue('--surface-0').trim() || '#05070a';
        ctx.fillRect(0, 0, w, h);
      }

      const count = parseInt(el('count').value, 10);
      const spread = parseInt(el('spread').value, 10) / 100;
      const strength = parseInt(el('strength').value, 10) / 100;
      const soft = parseInt(el('soft').value, 10) / 100;
      const seed = parseInt(el('seed').value, 10) || 1;
      const rand = rng(seed);
      const colours = brand();
      const short = Math.min(w, h);

      for (let i = 0; i < count; i += 1) {
        /* Positions are allowed past the edges so blobs run off the page
           rather than all sitting politely inside it, which is what makes the
           live background read as a field rather than a pattern. */
        const x = (rand() * 1.4 - 0.2) * w;
        const y = (rand() * 1.4 - 0.2) * h;
        const r = short * spread * (0.45 + rand() * 0.55);
        const colour = colours[i % colours.length];
        const alpha = (0.1 + rand() * 0.14) * strength;
        blob(ctx, x, y, r, colour, alpha, soft);
      }

      grain(ctx, w, h, parseInt(el('grain').value, 10));

      const meta = el('meta');
      if (meta) {
        meta.textContent =
          (window.themeStrings || {}).posterMeta
            ? (window.themeStrings || {}).posterMeta
                .replace('[w]', p.w.toFixed(2))
                .replace('[h]', p.h.toFixed(2))
                .replace('[px]', w + ' × ' + h)
                .replace('[dpi]', String(p.dpi))
            : p.w.toFixed(2) + '" × ' + p.h.toFixed(2) + '" — ' + w + ' × ' + h + ' px at ' + p.dpi + ' dpi';
      }
    }

    /* Redrawing eight megapixels on every slider tick is wasteful, so the work
       is coalesced and only the last request survives.

       A timer rather than requestAnimationFrame: this is not animation, it is
       one expensive job that should happen shortly after the fiddling stops,
       and rAF does not run at all when the page is not being painted — which
       leaves the controls looking broken rather than merely slow. */
    let queued = null;
    function redraw() {
      clearTimeout(queued);
      queued = setTimeout(render, 60);
    }

    $$('input, select', root).forEach((input) => {
      input.addEventListener('input', redraw);
      input.addEventListener('change', redraw);
    });

    /* Each slider writes its own number next to its label. */
    const pairs = [['count','count'],['spread','spread'],['strength','strength'],['soft','soft'],['grain','grain']];
    pairs.forEach(([key, out]) => {
      const input = el(key);
      const label = $('[data-poster-out="' + out + '"]', root);
      if (!input || !label) return;
      const sync = () => { label.textContent = input.value; };
      input.addEventListener('input', sync);
      sync();
    });

    sizeSel.addEventListener('change', () => {
      custom.hidden = sizeSel.value !== 'custom';
    });

    const shuffle = el('shuffle');
    if (shuffle) {
      shuffle.addEventListener('click', () => {
        el('seed').value = String(1 + Math.floor(Math.random() * 999999));
        redraw();
      });
    }

    const save = el('save');
    if (save) {
      save.addEventListener('click', () => {
        const p = paper();
        canvas.toBlob((blob) => {
          if (!blob) return;
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download =
            'picovr-background-' + p.w + 'x' + p.h + '-' + p.dpi + 'dpi-seed' + el('seed').value + '.png';
          document.body.appendChild(a);
          a.click();
          a.remove();
          /* Freed on the next tick; revoking immediately can cancel the
             download in some browsers before it has started reading. */
          setTimeout(() => URL.revokeObjectURL(url), 10000);
        }, 'image/png');
      });
    }


    /* ---------------------------------------------------------------- pdf */

    /* A PDF holding one full-page image is short enough to write out here,
       which is a better trade than shipping a PDF library to every visitor
       for a button only staff can reach.
       
       The picture goes in as JPEG, because DCTDecode takes JPEG bytes exactly
       as the canvas produces them — no re-encoding, and no need to implement
       deflate. The cost is that JPEG has no alpha, so a transparent poster is
       flattened onto the background first rather than coming out black. */
    function pdfBytes(jpeg, pxW, pxH, inW, inH) {
      const enc = new TextEncoder();
      /* PDF measures in points, and there are 72 to an inch whatever the
         resolution of the image placed on the page. */
      const ptW = (inW * 72).toFixed(2);
      const ptH = (inH * 72).toFixed(2);

      const content = 'q ' + ptW + ' 0 0 ' + ptH + ' 0 0 cm /Im0 Do Q\n';
      const objs = [
        '<< /Type /Catalog /Pages 2 0 R >>',
        '<< /Type /Pages /Kids [3 0 R] /Count 1 >>',
        '<< /Type /Page /Parent 2 0 R /MediaBox [0 0 ' + ptW + ' ' + ptH +
          '] /Resources << /XObject << /Im0 4 0 R >> >> /Contents 5 0 R >>',
        null, /* the image, written separately because it carries binary */
        '<< /Length ' + content.length + ' >>\nstream\n' + content + 'endstream',
      ];

      const parts = [];
      let at = 0;
      const push = (bytes) => {
        parts.push(bytes);
        at += bytes.length;
      };
      const text = (s) => push(enc.encode(s));

      text('%PDF-1.4\n');
      /* A comment of high bytes marks the file as binary, so anything moving
         it around treats it as such rather than mangling line endings. */
      push(new Uint8Array([0x25, 0xe2, 0xe3, 0xcf, 0xd3, 0x0a]));

      const offsets = [];
      for (let i = 0; i < objs.length; i += 1) {
        offsets.push(at);
        const n = i + 1;
        if (n === 4) {
          text(
            n + ' 0 obj\n<< /Type /XObject /Subtype /Image /Width ' + pxW +
              ' /Height ' + pxH +
              ' /ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter /DCTDecode /Length ' +
              jpeg.length + ' >>\nstream\n'
          );
          push(jpeg);
          text('\nendstream\nendobj\n');
        } else {
          text(n + ' 0 obj\n' + objs[i] + '\nendobj\n');
        }
      }

      const xrefAt = at;
      let xref = 'xref\n0 ' + (objs.length + 1) + '\n0000000000 65535 f \n';
      offsets.forEach((o) => {
        xref += String(o).padStart(10, '0') + ' 00000 n \n';
      });
      text(xref);
      text(
        'trailer\n<< /Size ' + (objs.length + 1) + ' /Root 1 0 R >>\nstartxref\n' +
          xrefAt + '\n%%EOF\n'
      );

      return new Blob(parts, { type: 'application/pdf' });
    }

    /* JPEG cannot carry transparency, so a poster asked for without a
       background is laid on one for the PDF. Silently letting it come out
       black would be worse than the flattening. */
    function flattened() {
      if (!el('transparent').checked) return canvas;
      const flat = document.createElement('canvas');
      flat.width = canvas.width;
      flat.height = canvas.height;
      const c = flat.getContext('2d');
      c.fillStyle =
        getComputedStyle(document.documentElement).getPropertyValue('--surface-0').trim() || '#05070a';
      c.fillRect(0, 0, flat.width, flat.height);
      c.drawImage(canvas, 0, 0);
      return flat;
    }

    const pdfBtn = el('pdf');
    if (pdfBtn) {
      pdfBtn.addEventListener('click', async () => {
        const p = paper();
        const src = flattened();
        const blob = await new Promise((r) => src.toBlob(r, 'image/jpeg', 0.92));
        if (!blob) return;
        const jpeg = new Uint8Array(await blob.arrayBuffer());
        const pdf = pdfBytes(jpeg, src.width, src.height, p.w, p.h);

        const url = URL.createObjectURL(pdf);
        const a = document.createElement('a');
        a.href = url;
        a.download =
          'picovr-background-' + p.w + 'x' + p.h + '-' + p.dpi + 'dpi-seed' + el('seed').value + '.pdf';
        document.body.appendChild(a);
        a.click();
        a.remove();
        setTimeout(() => URL.revokeObjectURL(url), 10000);
      });
    }

    const printBtn = el('print');
    if (printBtn) {
      printBtn.addEventListener('click', () => {
        const p = paper();
        const win = window.open('', '_blank');
        if (!win) return;
        /* A page sized to the paper with no margin, so the browser's print
           dialog lands on the right size without anyone setting scaling. */
        win.document.write(
          '<!doctype html><title>Background</title><style>' +
            '@page{size:' + p.w + 'in ' + p.h + 'in;margin:0}' +
            'html,body{margin:0;padding:0}img{display:block;width:100%;height:auto}' +
            '</style><img src="' + canvas.toDataURL('image/png') + '">'
        );
        win.document.close();
        win.focus();
        setTimeout(() => win.print(), 400);
      });
    }

    render();
  });

  /* ------------------------------------------------------------- qr codes */

  /* A QR encoder, written out rather than pulled in.

     The tool is staff-only and sits behind a gate customers never get past,
     so a library would be dead weight on every other page — and the format is
     frozen by ISO 18004, so this cannot rot the way a dependency can. Byte
     mode only: every link here is a URL, and the alphanumeric mode that would
     pack a few more characters in cannot carry a lowercase letter. */
  function qrEncode(text, level) {
    /* Error-correction codewords per block, and the number of blocks, for all
       40 versions. Everything else about a symbol's capacity falls out of
       these two, which is why they are the only tables here rather than the
       much larger one giving data capacity directly. */
    var ECW = {
      L: [0,7,10,15,20,26,18,20,24,30,18,20,24,26,30,22,24,28,30,28,28,28,28,30,30,26,28,30,30,30,30,30,30,30,30,30,30,30,30,30,30],
      M: [0,10,16,26,18,24,16,18,22,22,26,30,22,22,24,24,28,28,26,26,26,26,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28],
      Q: [0,13,22,18,26,18,24,18,22,20,24,28,26,24,20,30,24,28,28,26,30,28,30,30,30,30,28,30,30,30,30,30,30,30,30,30,30,30,30,30,30],
      H: [0,17,28,22,16,22,28,26,26,24,28,24,28,22,24,24,30,28,28,26,28,30,24,30,30,30,30,30,30,30,30,30,30,30,30,30,30,30,30,30,30]
    };
    var BLOCKS = {
      L: [0,1,1,1,1,1,2,2,2,2,4,4,4,4,4,6,6,6,6,7,8,8,9,9,10,12,12,12,13,14,15,16,17,18,19,19,20,21,22,24,25],
      M: [0,1,1,1,2,2,4,4,4,5,5,5,8,9,9,10,10,11,13,14,16,17,17,18,20,21,23,25,26,28,29,31,33,35,37,38,40,43,45,47,49],
      Q: [0,1,1,2,2,4,4,6,6,8,8,8,10,12,16,12,17,16,18,21,20,23,23,25,27,29,34,34,35,38,40,43,45,48,51,53,56,59,62,65,68],
      H: [0,1,1,2,4,4,4,5,6,8,8,11,11,16,16,18,16,19,21,25,25,25,34,30,32,35,37,40,42,45,48,51,54,57,60,63,66,70,74,77,81]
    };
    /* The two-bit code each level carries in the format information.
       Deliberately not in the order L, M, Q, H — the spec numbers them
       M, L, H, Q, and getting this wrong yields a symbol nothing reads. */
    var LEVEL_BITS = { L: 1, M: 0, Q: 3, H: 2 };

    var ecl = ECW[level] ? level : 'H';

    /* Every module in the symbol less the ones the function patterns claim.
       Not always a whole number of codewords: some versions end with a few
       remainder bits carrying nothing at all. */
    function rawModules(v) {
      var n = (16 * v + 128) * v + 64;
      if (v >= 2) {
        var align = Math.floor(v / 7) + 2;
        n -= (25 * align - 10) * align - 55;
        if (v >= 7) n -= 36;
      }
      return n;
    }
    function totalCodewords(v) {
      return Math.floor(rawModules(v) / 8);
    }
    function dataCodewords(v) {
      return totalCodewords(v) - ECW[ecl][v] * BLOCKS[ecl][v];
    }

    /* ------------------------------------------------------------ galois */

    /* GF(256) under the QR generator polynomial. Multiplication the long way
       rather than through log tables: it runs a few hundred times on a job
       measured in milliseconds, and a mistyped table entry is a bug that only
       shows up as a sticker nobody can scan. */
    function mul(a, b) {
      var z = 0;
      for (var i = 7; i >= 0; i -= 1) {
        z = (z << 1) ^ ((z >>> 7) * 0x11d);
        z ^= ((b >>> i) & 1) * a;
      }
      return z & 0xff;
    }

    function divisor(degree) {
      var out = new Uint8Array(degree);
      out[degree - 1] = 1;
      var root = 1;
      for (var i = 0; i < degree; i += 1) {
        for (var j = 0; j < degree; j += 1) {
          out[j] = mul(out[j], root);
          if (j + 1 < degree) out[j] ^= out[j + 1];
        }
        root = mul(root, 2);
      }
      return out;
    }

    function remainder(data, div) {
      var out = new Uint8Array(div.length);
      for (var d = 0; d < data.length; d += 1) {
        var factor = data[d] ^ out[0];
        out.copyWithin(0, 1);
        out[out.length - 1] = 0;
        for (var i = 0; i < div.length; i += 1) out[i] ^= mul(div[i], factor);
      }
      return out;
    }

    /* -------------------------------------------------------------- bits */

    var bytes = new TextEncoder().encode(text);
    function countBits(v) {
      return v <= 9 ? 8 : 16;
    }

    var version = 0;
    for (var v = 1; v <= 40; v += 1) {
      if (4 + countBits(v) + bytes.length * 8 <= dataCodewords(v) * 8) {
        version = v;
        break;
      }
    }
    /* Longer than the largest symbol can hold. Null rather than a throw, so
       the caller can say so on screen instead of dying halfway. */
    if (!version) return null;

    var bits = [];
    function push(value, len) {
      for (var i = len - 1; i >= 0; i -= 1) bits.push((value >>> i) & 1);
    }
    push(4, 4);
    push(bytes.length, countBits(version));
    for (var b = 0; b < bytes.length; b += 1) push(bytes[b], 8);

    var capacity = dataCodewords(version) * 8;
    /* The terminator is up to four zeros — fewer when the symbol is nearly
       full, which is why it is a minimum rather than a flat four. */
    push(0, Math.min(4, capacity - bits.length));
    push(0, (8 - (bits.length % 8)) % 8);
    for (var pad = 0xec; bits.length < capacity; pad ^= 0xec ^ 0x11) push(pad, 8);

    var data = new Uint8Array(bits.length / 8);
    for (var i2 = 0; i2 < bits.length; i2 += 1) {
      data[i2 >>> 3] |= bits[i2] << (7 - (i2 & 7));
    }

    /* -------------------------------------------------------- interleave */

    var blocks = BLOCKS[ecl][version];
    var eccLen = ECW[ecl][version];
    var total = totalCodewords(version);
    /* Blocks come in two sizes one codeword apart, shorter ones first.
       Derived, not tabulated. */
    var shortLen = Math.floor(total / blocks) - eccLen;
    var shortCount = blocks - (total % blocks);

    var div = divisor(eccLen);
    var dataBlocks = [];
    var eccBlocks = [];
    var at = 0;
    for (var k = 0; k < blocks; k += 1) {
      var len = shortLen + (k < shortCount ? 0 : 1);
      var block = data.subarray(at, at + len);
      at += len;
      dataBlocks.push(block);
      eccBlocks.push(remainder(block, div));
    }

    var codes = [];
    /* Read down the columns, skipping the short blocks' absent last cell.
       This is what spreads a scratch across every block instead of letting it
       destroy one outright. */
    for (var r = 0; r <= shortLen; r += 1) {
      for (var c = 0; c < blocks; c += 1) {
        if (r < dataBlocks[c].length) codes.push(dataBlocks[c][r]);
      }
    }
    for (var r2 = 0; r2 < eccLen; r2 += 1) {
      for (var c2 = 0; c2 < blocks; c2 += 1) codes.push(eccBlocks[c2][r2]);
    }

    /* -------------------------------------------------------------- draw */

    var size = version * 4 + 17;
    var grid = [];
    var fixed = [];
    for (var y0 = 0; y0 < size; y0 += 1) {
      grid.push(new Array(size).fill(false));
      fixed.push(new Array(size).fill(false));
    }
    function set(x, y, dark) {
      if (x < 0 || y < 0 || x >= size || y >= size) return;
      grid[y][x] = dark;
      fixed[y][x] = true;
    }

    /* Timing first, then the finders over the top — they overlap at the
       corners and it is the finder that has to survive. */
    for (var t = 0; t < size; t += 1) {
      set(6, t, t % 2 === 0);
      set(t, 6, t % 2 === 0);
    }
    [[3, 3], [size - 4, 3], [3, size - 4]].forEach(function (spot) {
      for (var dy = -4; dy <= 4; dy += 1) {
        for (var dx = -4; dx <= 4; dx += 1) {
          var ring = Math.max(Math.abs(dx), Math.abs(dy));
          set(spot[0] + dx, spot[1] + dy, ring !== 2 && ring !== 4);
        }
      }
    });

    var spots = [];
    if (version > 1) {
      var count = Math.floor(version / 7) + 2;
      var step = version === 32 ? 26 : Math.ceil((version * 4 + 4) / (count * 2 - 2)) * 2;
      spots.push(6);
      for (var p = size - 7; spots.length < count; p -= step) spots.splice(1, 0, p);
    }
    for (var ai = 0; ai < spots.length; ai += 1) {
      for (var aj = 0; aj < spots.length; aj += 1) {
        /* Three corners already hold finders. */
        var corner =
          (ai === 0 && aj === 0) ||
          (ai === 0 && aj === spots.length - 1) ||
          (ai === spots.length - 1 && aj === 0);
        if (corner) continue;
        for (var ady = -2; ady <= 2; ady += 1) {
          for (var adx = -2; adx <= 2; adx += 1) {
            set(spots[ai] + adx, spots[aj] + ady, Math.max(Math.abs(adx), Math.abs(ady)) !== 1);
          }
        }
      }
    }

    if (version >= 7) {
      var vrem = version;
      for (var vi = 0; vi < 12; vi += 1) vrem = (vrem << 1) ^ ((vrem >>> 11) * 0x1f25);
      var vbits = (version << 12) | vrem;
      for (var vj = 0; vj < 18; vj += 1) {
        var vbit = ((vbits >>> vj) & 1) !== 0;
        var va = size - 11 + (vj % 3);
        var vb = Math.floor(vj / 3);
        set(va, vb, vbit);
        set(vb, va, vbit);
      }
    }

    function format(mask) {
      var value = (LEVEL_BITS[ecl] << 3) | mask;
      var rem = value;
      for (var i = 0; i < 10; i += 1) rem = (rem << 1) ^ ((rem >>> 9) * 0x537);
      var fbits = ((value << 10) | rem) ^ 0x5412;
      function bit(n) {
        return ((fbits >>> n) & 1) !== 0;
      }
      for (var a = 0; a <= 5; a += 1) set(8, a, bit(a));
      set(8, 7, bit(6));
      set(8, 8, bit(7));
      set(7, 8, bit(8));
      for (var c = 9; c < 15; c += 1) set(14 - c, 8, bit(c));
      for (var d = 0; d < 8; d += 1) set(size - 1 - d, 8, bit(d));
      for (var e = 8; e < 15; e += 1) set(8, size - 15 + e, bit(e));
      /* One module is dark in every symbol ever made. */
      set(8, size - 8, true);
    }

    /* Called once with a throwaway mask purely to claim the format-information
       modules before the data walk starts. Without this the walk treats them
       as free space, writes payload into them, and every bit after that lands
       one place too early — a symbol that looks perfectly well formed and
       decodes to nothing. The real values are written again below once the
       mask has been chosen. */
    format(0);

    /* Up one column pair, down the next, stepping over the vertical timing
       line — which is why the column index skips from 6 to 5. */
    var cursor = 0;
    for (var right = size - 1; right >= 1; right -= 2) {
      if (right === 6) right = 5;
      for (var run = 0; run < size; run += 1) {
        for (var j2 = 0; j2 < 2; j2 += 1) {
          var x2 = right - j2;
          var upward = ((right + 1) & 2) === 0;
          var y2 = upward ? size - 1 - run : run;
          if (!fixed[y2][x2] && cursor < codes.length * 8) {
            grid[y2][x2] = ((codes[cursor >>> 3] >>> (7 - (cursor & 7))) & 1) !== 0;
            cursor += 1;
          }
        }
      }
    }

    function maskAt(m, x, y) {
      switch (m) {
        case 0: return (x + y) % 2 === 0;
        case 1: return y % 2 === 0;
        case 2: return x % 3 === 0;
        case 3: return (x + y) % 3 === 0;
        case 4: return (Math.floor(x / 3) + Math.floor(y / 2)) % 2 === 0;
        case 5: return ((x * y) % 2) + ((x * y) % 3) === 0;
        case 6: return ((((x * y) % 2) + ((x * y) % 3)) % 2) === 0;
        default: return ((((x + y) % 2) + ((x * y) % 3)) % 2) === 0;
      }
    }
    function applyMask(m) {
      for (var y = 0; y < size; y += 1) {
        for (var x = 0; x < size; x += 1) {
          if (!fixed[y][x] && maskAt(m, x, y)) grid[y][x] = !grid[y][x];
        }
      }
    }

    /* The four penalty rules from the spec. Every mask decodes; this only
       picks the one least likely to give a scanner trouble. */
    function penalty() {
      var score = 0;
      function sweep(get) {
        for (var a = 0; a < size; a += 1) {
          var line = '';
          var length = 1;
          for (var b2 = 0; b2 < size; b2 += 1) {
            line += get(a, b2) ? '1' : '0';
            if (b2 > 0 && get(a, b2) === get(a, b2 - 1)) {
              length += 1;
              if (length === 5) score += 3;
              else if (length > 5) score += 1;
            } else if (b2 > 0) {
              length = 1;
            }
          }
          /* A finder-shaped run anywhere else in the symbol is what sends a
             scanner hunting in the wrong place. */
          var found = line.match(/10111010000|00001011101/g);
          if (found) score += found.length * 40;
        }
      }
      sweep(function (a, b2) { return grid[a][b2]; });
      sweep(function (a, b2) { return grid[b2][a]; });

      for (var y = 0; y < size - 1; y += 1) {
        for (var x = 0; x < size - 1; x += 1) {
          var c = grid[y][x];
          if (c === grid[y][x + 1] && c === grid[y + 1][x] && c === grid[y + 1][x + 1]) score += 3;
        }
      }

      var dark = 0;
      for (var dy2 = 0; dy2 < size; dy2 += 1) {
        for (var dx2 = 0; dx2 < size; dx2 += 1) if (grid[dy2][dx2]) dark += 1;
      }
      var cells = size * size;
      score += Math.floor(Math.abs(dark * 20 - cells * 10) / cells) * 10;
      return score;
    }

    var best = 0;
    var bestScore = Infinity;
    for (var m2 = 0; m2 < 8; m2 += 1) {
      format(m2);
      applyMask(m2);
      var score2 = penalty();
      if (score2 < bestScore) {
        bestScore = score2;
        best = m2;
      }
      /* Masking is its own inverse, so this puts the grid back. */
      applyMask(m2);
    }
    format(best);
    applyMask(best);

    return { size: size, version: version, level: ecl, mask: best, grid: grid, fixed: fixed };
  }

  /* Glyphs that can sit in the middle, as path data in a 24x24 box.

     Path data only — no <rect> or <circle> — because the same strings are
     handed to Path2D for the PNG and written into the SVG, and a shape the
     canvas cannot parse would mean two files that quietly disagree. */
  var QR_GLYPHS = {
    discord: [{ d: 'M19.3 5.36A16.5 16.5 0 0 0 15.2 4.1a.06.06 0 0 0-.07.03c-.18.32-.38.73-.52 1.05a15.3 15.3 0 0 0-4.6 0c-.14-.33-.35-.73-.53-1.05a.06.06 0 0 0-.07-.03c-1.44.25-2.82.68-4.1 1.26a.06.06 0 0 0-.03.02C2.66 9.25 1.99 13.03 2.32 16.76a.07.07 0 0 0 .03.05 16.6 16.6 0 0 0 5 2.53.07.07 0 0 0 .07-.02c.39-.53.73-1.08 1.02-1.67a.06.06 0 0 0-.03-.09c-.54-.2-1.06-.45-1.56-.73a.06.06 0 0 1-.01-.11l.31-.24a.06.06 0 0 1 .06-.01 11.8 11.8 0 0 0 10.05 0 .06.06 0 0 1 .07.01l.3.24a.06.06 0 0 1 0 .11c-.5.29-1.02.53-1.56.73a.06.06 0 0 0-.04.09c.3.59.64 1.14 1.02 1.67a.06.06 0 0 0 .07.02 16.5 16.5 0 0 0 5.01-2.53.06.06 0 0 0 .03-.05c.4-4.32-.66-8.07-2.8-11.4a.05.05 0 0 0-.03-.02ZM8.89 14.49c-.99 0-1.8-.91-1.8-2.02 0-1.12.8-2.02 1.8-2.02 1 0 1.81.91 1.8 2.02 0 1.11-.8 2.02-1.8 2.02Zm6.23 0c-.99 0-1.8-.91-1.8-2.02 0-1.12.79-2.02 1.8-2.02 1 0 1.81.91 1.8 2.02 0 1.11-.8 2.02-1.8 2.02Z' }],
    tracker: [
      { d: 'M8.5 4H15.5A4.5 4.5 0 0 1 20 8.5V15.5A4.5 4.5 0 0 1 15.5 20H8.5A4.5 4.5 0 0 1 4 15.5V8.5A4.5 4.5 0 0 1 8.5 4Z', stroke: 1.8 },
      { d: 'M12 9a3 3 0 1 1 0 6 3 3 0 0 1 0-6Z' },
    ],
    headset: [
      { d: 'M4 13v-1a8 8 0 0 1 16 0v1', stroke: 1.8 },
      { d: 'M4 13H6A2 2 0 0 1 8 15V18A2 2 0 0 1 6 20H4A2 2 0 0 1 2 18V15A2 2 0 0 1 4 13Z', stroke: 1.8 },
      { d: 'M18 13H20A2 2 0 0 1 22 15V18A2 2 0 0 1 20 20H18A2 2 0 0 1 16 18V15A2 2 0 0 1 18 13Z', stroke: 1.8 },
    ],
    cube: [
      { d: 'M12 2.8 20.2 7.5V16.9L12 21.6 3.8 16.9V7.5Z', stroke: 1.8 },
      { d: 'M3.8 7.5 12 12.2 20.2 7.5', stroke: 1.8 },
      { d: 'M12 12.2V21.6', stroke: 1.8 },
    ],
    wifi: [
      { d: 'M4.6 11.4a10.5 10.5 0 0 1 14.8 0', stroke: 2 },
      { d: 'M7.8 14.6a6 6 0 0 1 8.4 0', stroke: 2 },
      { d: 'M12 17.2a1.4 1.4 0 1 1 0 2.8 1.4 1.4 0 0 1 0-2.8Z' },
    ],
    bolt: [{ d: 'M13 2 4 14h7l-1 8 9-12h-7z', stroke: 1.8 }],
    link: [
      { d: 'M10.2 13.8a4.6 4.6 0 0 0 6.5 0l2.8-2.8a4.6 4.6 0 0 0-6.5-6.5l-1.4 1.4', stroke: 2 },
      { d: 'M13.8 10.2a4.6 4.6 0 0 0-6.5 0l-2.8 2.8a4.6 4.6 0 0 0 6.5 6.5l1.4-1.4', stroke: 2 },
    ],
    star: [{ d: 'm12 3 2.7 5.9 6.3.7-4.7 4.3 1.3 6.1L12 17l-5.6 3 1.3-6.1L3 9.6l6.3-.7z' }],
    sparkle: [{ d: 'M12 3l2.2 5.8L20 11l-5.8 2.2L12 19l-2.2-5.8L4 11l5.8-2.2z', stroke: 1.8 }],
    cart: [
      { d: 'M3.6 4.8h2.2l2.4 10.4a1.7 1.7 0 0 0 1.7 1.3h7.4a1.7 1.7 0 0 0 1.6-1.3l1.5-6.3H7.2', stroke: 1.8 },
      { d: 'M9.1 18.3a1.3 1.3 0 1 1 0 2.6 1.3 1.3 0 0 1 0-2.6Z' },
      { d: 'M17.3 18.3a1.3 1.3 0 1 1 0 2.6 1.3 1.3 0 0 1 0-2.6Z' },
    ],
    print: [
      { d: 'M7 8V3.6h10V8', stroke: 1.8 },
      { d: 'M7 16.4H5.2A2.2 2.2 0 0 1 3 14.2v-4A2.2 2.2 0 0 1 5.2 8h13.6A2.2 2.2 0 0 1 21 10.2v4a2.2 2.2 0 0 1-2.2 2.2H17', stroke: 1.8 },
      { d: 'M7 13.6h10v6.8H7z', stroke: 1.8 },
    ],
  };

  /* How far the plate behind the glyph reaches past the glyph itself. One
     constant, because the knockout is sized from it and both the canvas and
     the SVG draw from it — three places that have to agree exactly. */
  var QR_PLATE = 1.35;

  /* Three decimal places is finer than any printer resolves, and keeps the
     path data from bloating: a version 40 symbol is over 1,700 modules. */
  function qrNum(v) {
    return String(Math.round(v * 1000) / 1000);
  }

  /* A rectangle with every corner rounded independently. That independence is
     what lets neighbouring modules fuse into one shape instead of sitting in
     a row like beads. */
  function qrBox(x, y, w, h, tl, tr, br, bl) {
    return (
      'M' + qrNum(x + tl) + ' ' + qrNum(y) +
      'H' + qrNum(x + w - tr) +
      (tr ? 'A' + qrNum(tr) + ' ' + qrNum(tr) + ' 0 0 1 ' + qrNum(x + w) + ' ' + qrNum(y + tr) : '') +
      'V' + qrNum(y + h - br) +
      (br ? 'A' + qrNum(br) + ' ' + qrNum(br) + ' 0 0 1 ' + qrNum(x + w - br) + ' ' + qrNum(y + h) : '') +
      'H' + qrNum(x + bl) +
      (bl ? 'A' + qrNum(bl) + ' ' + qrNum(bl) + ' 0 0 1 ' + qrNum(x) + ' ' + qrNum(y + h - bl) : '') +
      'V' + qrNum(y + tl) +
      (tl ? 'A' + qrNum(tl) + ' ' + qrNum(tl) + ' 0 0 1 ' + qrNum(x + tl) + ' ' + qrNum(y) : '') +
      'Z'
    );
  }

  /* Where the glyph and its plate sit, in the same module-unit space as the
     paths, so the canvas and the SVG place them identically. */
  function qrGlyphBox(state) {
    var mid = state.geo.total / 2;
    var span = state.qr.size * state.o.glyphScale;
    return { x: mid - span / 2, y: mid - span / 2, size: span, mid: mid };
  }

  /* The whole symbol as two path strings: the body, and the three finders.
     Everything downstream — preview, PNG, SVG — draws these and nothing else,
     which is what keeps the vector a printer opens identical to the picture
     that was approved on screen. */
  function qrGeometry(qr, o) {
    var size = qr.size;
    var quiet = o.quiet;
    var r = o.radius;

    function isEye(x, y) {
      return (x < 7 && y < 7) || (x >= size - 7 && y < 7) || (x < 7 && y >= size - 7);
    }

    /* Modules under the glyph are left out rather than painted over. On a
       transparent sticker, painting over them would put a solid patch in the
       middle of nothing; leaving them out keeps the hole a hole. */
    var hole = o.hole;
    function inHole(x, y) {
      return !!hole && x >= hole.x0 && x < hole.x1 && y >= hole.y0 && y < hole.y1;
    }
    function dark(x, y) {
      if (x < 0 || y < 0 || x >= size || y >= size) return false;
      if (isEye(x, y) || inHole(x, y)) return false;
      return qr.grid[y][x];
    }

    var body = '';
    var dropped = 0;
    var live = 0;
    for (var y = 0; y < size; y += 1) {
      for (var x = 0; x < size; x += 1) {
        if (!isEye(x, y)) {
          live += 1;
          if (inHole(x, y)) dropped += 1;
        }
        if (!dark(x, y)) continue;
        var px = quiet + x;
        var py = quiet + y;
        if (o.style === 'square') {
          body += qrBox(px, py, 1, 1, 0, 0, 0, 0);
        } else if (o.style === 'dot') {
          body += qrBox(px, py, 1, 1, r, r, r, r);
        } else {
          /* A corner is rounded only where nothing is attached on either side
             of it, so a run of modules reads as one continuous stroke and a
             lone module comes out as a dot. */
          var up = dark(x, y - 1);
          var down = dark(x, y + 1);
          var left = dark(x - 1, y);
          var right = dark(x + 1, y);
          body += qrBox(
            px, py, 1, 1,
            !up && !left ? r : 0,
            !up && !right ? r : 0,
            !down && !right ? r : 0,
            !down && !left ? r : 0
          );
        }
      }
    }

    /* The three finders, drawn as rings so they can take their own colour and
       their own rounding without the module loop having to know about them.
       Filled even-odd: outer square, hole, dot. */
    var er = o.eyeRadius * 3.5;
    var ir = Math.max(0, er - 1);
    var dr = o.eyeRadius * 1.5;
    var eyes = '';
    [[0, 0], [size - 7, 0], [0, size - 7]].forEach(function (spot) {
      var ex = quiet + spot[0];
      var ey = quiet + spot[1];
      eyes += qrBox(ex, ey, 7, 7, er, er, er, er);
      eyes += qrBox(ex + 1, ey + 1, 5, 5, ir, ir, ir, ir);
      eyes += qrBox(ex + 2, ey + 2, 3, 3, dr, dr, dr, dr);
    });

    return { total: size + quiet * 2, body: body, eyes: eyes, dropped: dropped, live: live };
  }

  /* The vector file. Written out rather than serialised from the preview,
     because a canvas has no vector to give back — and a sticker printer wants
     paths it can scale, not pixels it has to interpolate. */
  function qrSvg(state) {
    var o = state.o;
    var geo = state.geo;
    var t = qrNum(geo.total);
    var parts = [];

    parts.push(
      '<svg xmlns="http://www.w3.org/2000/svg" width="' + o.inches + 'in" height="' +
        o.inches + 'in" viewBox="0 0 ' + t + ' ' + t + '" shape-rendering="geometricPrecision">'
    );
    if (!o.transparent) {
      var pr = qrNum(o.plateR);
      parts.push('<rect width="' + t + '" height="' + t + '" rx="' + pr + '" ry="' + pr +
        '" fill="' + o.bg + '"/>');
    }
    parts.push('<path fill="' + o.fg + '" d="' + geo.body + '"/>');
    parts.push('<path fill="' + o.eyeColor + '" fill-rule="evenodd" d="' + geo.eyes + '"/>');

    if (state.glyphOn) {
      var g = qrGlyphBox(state);
      if (o.pad !== 'none') {
        var w = g.size * QR_PLATE;
        var pad = o.pad === 'circle' ? w / 2 : g.size * 0.22;
        parts.push('<rect x="' + qrNum(g.mid - w / 2) + '" y="' + qrNum(g.mid - w / 2) +
          '" width="' + qrNum(w) + '" height="' + qrNum(w) + '" rx="' + qrNum(pad) +
          '" ry="' + qrNum(pad) + '" fill="' + o.padColor + '"/>');
      }
      if (o.glyph === 'image' && o.mark) {
        var ratio = Math.min(g.size / o.mark.naturalWidth, g.size / o.mark.naturalHeight);
        var iw = o.mark.naturalWidth * ratio;
        var ih = o.mark.naturalHeight * ratio;
        parts.push('<image href="' + o.mark.src + '" x="' + qrNum(g.mid - iw / 2) + '" y="' +
          qrNum(g.mid - ih / 2) + '" width="' + qrNum(iw) + '" height="' + qrNum(ih) + '"/>');
      } else if (QR_GLYPHS[o.glyph]) {
        parts.push('<g transform="translate(' + qrNum(g.x) + ' ' + qrNum(g.y) + ') scale(' +
          qrNum(g.size / 24) + ')" stroke-linecap="round" stroke-linejoin="round">');
        QR_GLYPHS[o.glyph].forEach(function (p) {
          parts.push(p.stroke
            ? '<path d="' + p.d + '" fill="none" stroke="' + o.glyphColor +
              '" stroke-width="' + p.stroke + '"/>'
            : '<path d="' + p.d + '" fill="' + o.glyphColor + '"/>');
        });
        parts.push('</g>');
      }
    }
    parts.push('</svg>');
    return parts.join('');
  }

  /* Everything needed to draw, from a link and a set of choices. Kept apart
     from the controls so one call feeds the preview, the PNG and the SVG —
     they cannot disagree when there is only one of it. */
  function qrCompose(o) {
    if (!o.text) return null;
    var qr = qrEncode(o.text, o.level);
    if (!qr) return null;

    var glyphOn = o.glyph !== 'none' && (o.glyph !== 'image' || !!o.mark);
    var hole = null;
    if (glyphOn) {
      var span = qr.size * o.glyphScale;
      /* Sized off the plate rather than the glyph. The plate grows with the
         glyph, so a fixed margin is enough on a small symbol and too little
         on a large one — which shows as modules poking out from under it.
         Snapped outwards to whole modules, because a half-erased module is
         exactly what makes a code hard to read. */
      var half = (o.pad === 'none' ? span / 2 : (span * QR_PLATE) / 2) + 0.5;
      var mid = qr.size / 2;
      hole = {
        x0: Math.floor(mid - half),
        x1: Math.ceil(mid + half),
        y0: Math.floor(mid - half),
        y1: Math.ceil(mid + half),
      };
    }
    o.hole = hole;

    var geo = qrGeometry(qr, o);

    /* Rounding the sticker's own corners eats the plate away from the corners
       inwards. Past a point the arc crosses the quiet zone and starts clipping
       the finder patterns, which leaves a code that scans on white paper --
       the paper standing in for the background it lost -- and fails on
       coloured vinyl.

       The limit is geometry: the corner of the code square sits at (q, q) from
       the sticker's edge, and a corner arc of radius r keeps that point inside
       only while r is at most q(2 + root 2). With no quiet zone at all, no
       rounding is safe, which is exactly right. */
    var ceiling = Math.min(geo.total / 2, o.quiet * (2 + Math.SQRT2));
    var asked = o.plateRadius * (geo.total / 2);
    o.plateR = Math.min(asked, ceiling);
    o.plateClamped = asked > ceiling + 0.001;

    return { o: o, qr: qr, geo: geo, glyphOn: glyphOn };
  }

  /* -------------------------------------------------------------- qr tool */

  /* Turns a link into a sticker, entirely in the page. Nothing goes to a QR
     service, which also means no printed sticker depends on somebody else's
     redirector still being alive in two years. */
  $$('[data-qr]').forEach(function (root) {
    var canvas = $('[data-qr-canvas]', root);
    if (!canvas) return;

    function el(name) {
      return $('[data-qr-' + name + ']', root);
    }
    var out = el('meta');
    var warn = el('warn');

    /* An uploaded or theme-picked mark, once it has finished loading. */
    var mark = null;
    var current = null;

    function read() {
      var inches = el('size').value === 'custom'
        ? Math.min(12, Math.max(0.5, parseFloat(el('inches').value) || 2))
        : parseFloat(el('size').value);

      return {
        text: (el('link').value || '').trim(),
        level: el('level').value,
        quiet: parseInt(el('quiet').value, 10),
        style: el('style').value,
        radius: (parseInt(el('radius').value, 10) || 0) / 200,
        eyeRadius: (parseInt(el('eyes').value, 10) || 0) / 100,
        fg: el('fg').value,
        eyeColor: el('eyecolor').value,
        bg: el('bg').value,
        transparent: el('transparent').checked,
        plateRadius: (parseInt(el('plate').value, 10) || 0) / 100,
        glyph: el('glyph').value,
        glyphScale: Math.min(0.3, Math.max(0.08, (parseInt(el('scale').value, 10) || 20) / 100)),
        glyphColor: el('glyphcolor').value,
        pad: el('pad').value,
        padColor: el('padcolor').value,
        mark: mark,
        inches: inches,
        dpi: parseInt(el('dpi').value, 10) || 300,
      };
    }

    function draw() {
      var state = qrCompose(read());
      current = state;

      if (!state) {
        canvas.width = 8;
        canvas.height = 8;
        canvas.getContext('2d').clearRect(0, 0, 8, 8);
        report(null);
        return;
      }

      var o = state.o;
      var geo = state.geo;
      var px = Math.max(64, Math.round(o.inches * o.dpi));
      canvas.width = px;
      canvas.height = px;

      var ctx = canvas.getContext('2d');
      ctx.clearRect(0, 0, px, px);
      ctx.save();
      ctx.scale(px / geo.total, px / geo.total);

      if (!o.transparent) {
        var pr = o.plateR;
        ctx.fillStyle = o.bg;
        ctx.fill(new Path2D(qrBox(0, 0, geo.total, geo.total, pr, pr, pr, pr)));
      }

      ctx.fillStyle = o.fg;
      ctx.fill(new Path2D(geo.body));
      ctx.fillStyle = o.eyeColor;
      ctx.fill(new Path2D(geo.eyes), 'evenodd');

      if (state.glyphOn) {
        var g = qrGlyphBox(state);
        if (o.pad !== 'none') {
          var w = g.size * QR_PLATE;
          var pad = o.pad === 'circle' ? w / 2 : g.size * 0.22;
          ctx.fillStyle = o.padColor;
          ctx.fill(new Path2D(qrBox(g.mid - w / 2, g.mid - w / 2, w, w, pad, pad, pad, pad)));
        }
        drawGlyph(ctx, o, g);
      }

      ctx.restore();
      report(state);
    }

    function drawGlyph(ctx, o, g) {
      if (o.glyph === 'image') {
        if (!o.mark) return;
        /* Fitted inside the box rather than stretched to it. A squashed logo
           is worse than a smaller one. */
        var ratio = Math.min(g.size / o.mark.naturalWidth, g.size / o.mark.naturalHeight);
        var w = o.mark.naturalWidth * ratio;
        var h = o.mark.naturalHeight * ratio;
        ctx.drawImage(o.mark, g.mid - w / 2, g.mid - h / 2, w, h);
        return;
      }
      var paths = QR_GLYPHS[o.glyph];
      if (!paths) return;
      ctx.save();
      ctx.translate(g.x, g.y);
      ctx.scale(g.size / 24, g.size / 24);
      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';
      ctx.fillStyle = o.glyphColor;
      ctx.strokeStyle = o.glyphColor;
      paths.forEach(function (p) {
        var path = new Path2D(p.d);
        if (p.stroke) {
          ctx.lineWidth = p.stroke;
          ctx.stroke(path);
        } else {
          ctx.fill(path);
        }
      });
      ctx.restore();
    }

    /* ------------------------------------------------------------ report */

    function say(node, message) {
      if (!node) return;
      node.textContent = message || '';
      node.hidden = !message;
    }

    function fill(template, values) {
      var text = template || '';
      Object.keys(values).forEach(function (key) {
        text = text.split('[' + key + ']').join(values[key]);
      });
      return text;
    }

    function report(state) {
      var strings = window.themeStrings || {};
      if (!state) {
        say(out, '');
        say(warn, (el('link').value || '').trim() ? strings.qrTooLong : strings.qrNoLink);
        return;
      }
      var o = state.o;
      var px = Math.round(o.inches * o.dpi);
      say(out, fill(strings.qrMeta, {
        v: state.qr.version,
        e: o.level,
        m: state.qr.size + ' × ' + state.qr.size,
        px: px + ' × ' + px,
        dpi: o.dpi,
      }));

      /* The one number worth watching. Error correction is what pays for the
         hole in the middle, and there is a point past which no amount of it
         helps. Warned at seven tenths of the budget, because the printed
         article also has to survive being stuck to something. */
      var notes = [];
      var lost = state.geo.live ? (state.geo.dropped / state.geo.live) * 100 : 0;
      var budget = { L: 7, M: 15, Q: 25, H: 30 }[o.level];
      if (lost > budget * 0.7) {
        notes.push(fill(strings.qrCovered, {
          pct: lost.toFixed(0), level: o.level, budget: budget,
        }));
      }
      /* Said out loud rather than letting the slider sit at a number it is
         not honouring, which would look like a bug in the tool. */
      if (o.plateClamped) notes.push(strings.qrPlateLimited);
      say(warn, notes.join(' '));
    }

    /* ------------------------------------------------------------ saving */

    function stem() {
      var name = (el('link').value || 'qr')
        .replace(/^https?:\/\//, '')
        .replace(/[^a-z0-9]+/gi, '-')
        .replace(/^-+|-+$/g, '')
        .toLowerCase()
        .slice(0, 48);
      return 'picovr-qr-' + (name || 'link');
    }

    function offer(blob, filename) {
      var url = URL.createObjectURL(blob);
      var a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      /* Freed on a delay: revoking straight away can cancel the download
         before the browser has finished reading it. */
      setTimeout(function () { URL.revokeObjectURL(url); }, 10000);
    }

    var png = el('png');
    if (png) {
      png.addEventListener('click', function () {
        if (!current) return;
        canvas.toBlob(function (blob) {
          if (blob) offer(blob, stem() + '-' + current.o.inches + 'in.png');
        }, 'image/png');
      });
    }

    var svg = el('svg');
    if (svg) {
      svg.addEventListener('click', function () {
        if (!current) return;
        offer(
          new Blob([qrSvg(current)], { type: 'image/svg+xml' }),
          stem() + '-' + current.o.inches + 'in.svg'
        );
      });
    }

    /* ------------------------------------------------------------ wiring */

    var queued = null;
    function schedule() {
      clearTimeout(queued);
      queued = setTimeout(draw, 90);
    }

    $$('input, select', root).forEach(function (input) {
      input.addEventListener('input', schedule);
      input.addEventListener('change', schedule);
    });

    /* Each slider shows its own number: "34" means nothing on a bare track,
       and the point is being able to get back to a setting that worked. */
    [['radius', 'radius'], ['eyes', 'eyes'], ['quiet', 'quiet'], ['scale', 'scale'],
      ['plate', 'plate']].forEach(function (pair) {
      var input = el(pair[0]);
      var label = $('[data-qr-out="' + pair[1] + '"]', root);
      if (!input || !label) return;
      var sync = function () { label.textContent = input.value; };
      input.addEventListener('input', sync);
      sync();
    });

    /* Controls that only apply to some choices are hidden rather than
       disabled, so the panel stays short enough to take in at a glance. */
    function toggles() {
      [
        ['custom', el('size').value !== 'custom'],
        ['upload', el('glyph').value !== 'image'],
        ['radiusrow', el('style').value === 'square'],
        ['padcolorrow', el('pad').value === 'none'],
      ].forEach(function (pair) {
        var node = el(pair[0]);
        if (node) node.hidden = pair[1];
      });
    }
    ['size', 'glyph', 'style', 'pad'].forEach(function (name) {
      var input = el(name);
      if (input) input.addEventListener('change', toggles);
    });
    toggles();

    /* Preset links from the theme editor. Sets the glyph too, since the whole
       reason for a preset is that the sticker is the same every time. */
    $$('[data-qr-preset]', root).forEach(function (button) {
      button.addEventListener('click', function () {
        el('link').value = button.dataset.url || '';
        var wanted = button.dataset.glyph;
        if (wanted && $('option[value="' + wanted + '"]', el('glyph'))) {
          el('glyph').value = wanted;
        }
        toggles();
        draw();
      });
    });

    /* An uploaded mark. Raster only: an SVG drawn onto a canvas taints it in
       some browsers, and a tainted canvas cannot be saved at all — which
       would break Save PNG with nothing on screen to explain why. */
    var file = el('file');
    if (file) {
      file.addEventListener('change', function () {
        var chosen = file.files && file.files[0];
        if (!chosen) return;
        var reader = new FileReader();
        reader.onload = function () {
          var img = new Image();
          img.onload = function () {
            mark = img;
            draw();
          };
          img.onerror = function () {
            mark = null;
            say(warn, (window.themeStrings || {}).qrBadImage);
          };
          img.src = reader.result;
        };
        reader.readAsDataURL(chosen);
      });
    }

    /* A mark chosen in the theme editor, so the usual sticker needs no upload
       at all.

       Redrawn through a canvas into a data URL rather than used as it comes.
       That bakes the picture into the SVG, which would otherwise hold only a
       link to the CDN — a file that looks right here and reaches the printer
       with a hole in it. It also forces any cross-origin problem to surface
       now, with something on screen to read, rather than as a Save PNG button
       that throws. */
    var preset = root.dataset.mark;
    if (preset) {
      var source = new Image();
      source.crossOrigin = 'anonymous';
      source.onload = function () {
        var flat = document.createElement('canvas');
        flat.width = source.naturalWidth;
        flat.height = source.naturalHeight;
        flat.getContext('2d').drawImage(source, 0, 0);
        var inlined = new Image();
        inlined.onload = function () {
          mark = inlined;
          if (el('glyph').value === 'image') draw();
        };
        try {
          inlined.src = flat.toDataURL('image/png');
        } catch (err) {
          say(warn, (window.themeStrings || {}).qrMarkBlocked);
        }
      };
      source.src = preset;
    }

    draw();
  });

  /* --------------------------------------------------------- print quote */

  /* Measures an STL in the browser and prices it. Nothing is uploaded to get
     a number — a curious visitor never sends a file anywhere, and the shop
     never receives models it was not asked to print. */
  $$('[data-print-quote]').forEach((root) => {
    const file = $('[data-pq-file]', root);
    const carry = $('[data-pq-carry]', root);
    const out = $('[data-pq-out]', root);
    const err = $('[data-pq-error]', root);
    if (!file) return;

    const cfg = {
      perGram: parseFloat(root.dataset.perGram) || 0,
      handling: parseFloat(root.dataset.handling) || 0,
      minGrams: parseInt(root.dataset.minGrams, 10) || 0,
      maxBytes: (parseFloat(root.dataset.maxMb) || 20) * 1024 * 1024,
      shell: (parseFloat(root.dataset.shell) || 35) / 100,
      hourly: parseFloat(root.dataset.hourly) || 0,
      throughput: parseFloat(root.dataset.throughput) || 11,
      layer: parseFloat(root.dataset.layer) || 0.2,
      minLayer: parseFloat(root.dataset.minLayer) || 0,
      bed: [
        parseFloat(root.dataset.bedX) || 0,
        parseFloat(root.dataset.bedY) || 0,
        parseFloat(root.dataset.bedZ) || 0,
      ],
    };

    let model = null;

    /* ---------------------------------------------------------- parsing */

    /* An STL is a bag of triangles with no units attached. Everyone treats
       them as millimetres because that is what every slicer assumes, so the
       numbers below are mm and mm³. */
    function parseBinary(buf) {
      /* Anything shorter than the header cannot be binary, and reading past
         the end of a DataView throws rather than returning nothing — which
         took the whole handler down and left the previous error on screen. */
      if (buf.byteLength < 84) return null;
      const view = new DataView(buf);
      const count = view.getUint32(80, true);
      /* 84 byte header, then 50 bytes a triangle. If that does not match the
         file length it is not binary, whatever the extension says. */
      if (84 + count * 50 !== buf.byteLength) return null;

      const tris = new Float32Array(count * 9);
      let at = 84;
      for (let i = 0; i < count; i += 1) {
        at += 12; /* the normal, which is not trustworthy and not needed */
        for (let j = 0; j < 9; j += 1) {
          tris[i * 9 + j] = view.getFloat32(at, true);
          at += 4;
        }
        at += 2; /* attribute byte count */
      }
      return tris;
    }

    function parseAscii(text) {
      const nums = [];
      const re = /vertex\s+(-?[\d.eE+-]+)\s+(-?[\d.eE+-]+)\s+(-?[\d.eE+-]+)/g;
      let m;
      while ((m = re.exec(text))) {
        nums.push(parseFloat(m[1]), parseFloat(m[2]), parseFloat(m[3]));
      }
      if (nums.length < 9 || nums.length % 9 !== 0) return null;
      return Float32Array.from(nums);
    }

    /* ------------------------------------------------------------ maths */

    /**
     * Volume by the signed-tetrahedron sum.
     *
     * Every triangle forms a tetrahedron with the origin. Signed volumes of
     * those cancel out everywhere the surface doubles back, so the total is
     * the enclosed volume however the mesh is positioned — no need to move it
     * anywhere first. Taken absolute at the end because a mesh wound
     * inside-out gives the right magnitude with the wrong sign.
     */
    function measure(tris) {
      let vol = 0;
      const min = [Infinity, Infinity, Infinity];
      const max = [-Infinity, -Infinity, -Infinity];

      for (let i = 0; i < tris.length; i += 9) {
        const ax = tris[i], ay = tris[i + 1], az = tris[i + 2];
        const bx = tris[i + 3], by = tris[i + 4], bz = tris[i + 5];
        const cx = tris[i + 6], cy = tris[i + 7], cz = tris[i + 8];

        vol +=
          (ax * (by * cz - bz * cy) -
            ay * (bx * cz - bz * cx) +
            az * (bx * cy - by * cx)) / 6;

        for (let k = 0; k < 3; k += 1) {
          const a = tris[i + k], b = tris[i + 3 + k], c = tris[i + 6 + k];
          if (a < min[k]) min[k] = a;
          if (b < min[k]) min[k] = b;
          if (c < min[k]) min[k] = c;
          if (a > max[k]) max[k] = a;
          if (b > max[k]) max[k] = b;
          if (c > max[k]) max[k] = c;
        }
      }

      return {
        mm3: Math.abs(vol),
        min: min,
        size: [max[0] - min[0], max[1] - min[1], max[2] - min[2]],
        triangles: tris.length / 9,
      };
    }

    /**
     * Grams of filament.
     *
     * A print is not solid, so the solid volume is scaled: the shell is always
     * there, and the inside is only as full as the infill setting. Both are
     * settings because the right shell share depends on how big the parts are
     * and what wall count you slice with — a small part is nearly all shell.
     *
     * This is an estimate and it is not a slice. It cannot see supports,
     * brims, or the fact that a thin lattice is mostly perimeter.
     */
    function extruded(mm3, infill) {
      return mm3 * (cfg.shell + (1 - cfg.shell) * infill);
    }

    function grams(mm3, density, infill, multiplier) {
      return (extruded(mm3, infill) / 1000) * density * multiplier;
    }

    /**
     * Roughly how long it will sit on the bed.
     *
     * Volume alone is not enough. A tall thin part weighs nothing and takes
     * hours, because every layer has a floor on its time — the plastic has to
     * cool before the next one lands — and a spindly part hits that floor on
     * every one of them. So each layer is charged the greater of what the
     * machine can extrude and what the cooling needs, which is what separates
     * a rod from a puck of the same weight.
     *
     * Layer volume is assumed even through the height, which it never quite
     * is. This is a guide, not a slice.
     */
    function hours(mm3, height, infill) {
      const mat = extruded(mm3, infill);
      const layers = Math.max(1, Math.ceil(height / cfg.layer));
      const perSecond = (cfg.throughput * 1000) / 3600;
      const perLayer = Math.max(mat / layers / perSecond, cfg.minLayer);
      return (layers * perLayer) / 3600;
    }


    /* ----------------------------------------------------------- preview */

    /* Flat-shaded isometric, painted back to front on a 2D canvas.
       The triangles are already in hand from measuring the volume, so this
       costs one pass over them and no library. */
    const canvas = $('[data-pq-canvas]', root);
    const view = { yaw: -0.6, pitch: 0.5, tris: null, bounds: null };

    function rotate(x, y, z) {
      /* Yaw about the vertical, then pitch towards the viewer. Z is up in an
         STL, so it is the axis that stays put under yaw. */
      const cy = Math.cos(view.yaw), sy = Math.sin(view.yaw);
      const cp = Math.cos(view.pitch), sp = Math.sin(view.pitch);
      const x1 = x * cy - y * sy;
      const y1 = x * sy + y * cy;
      return {
        x: x1,
        y: y1 * cp - z * sp,
        /* Depth, and also what the shading reads off. */
        z: y1 * sp + z * cp,
      };
    }

    function draw() {
      if (!canvas || !view.tris) return;
      const ctx = canvas.getContext('2d');
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      const w = canvas.clientWidth || 640;
      const h = canvas.clientHeight || 420;
      if (canvas.width !== Math.round(w * dpr)) {
        canvas.width = Math.round(w * dpr);
        canvas.height = Math.round(h * dpr);
      }
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      ctx.clearRect(0, 0, w, h);

      const t = view.tris;
      const c = view.bounds.centre;
      const faces = [];

      for (let i = 0; i < t.length; i += 9) {
        const a = rotate(t[i] - c[0], t[i + 1] - c[1], t[i + 2] - c[2]);
        const b = rotate(t[i + 3] - c[0], t[i + 4] - c[1], t[i + 5] - c[2]);
        const d = rotate(t[i + 6] - c[0], t[i + 7] - c[1], t[i + 8] - c[2]);

        /* Screen-space winding tells us which way the face points once it is
           already rotated, so no normal has to be carried around. Backfaces
           are dropped, which halves the work before sorting. */
        const cross = (b.x - a.x) * (d.y - a.y) - (b.y - a.y) * (d.x - a.x);
        if (cross <= 0) continue;

        faces.push({ a: a, b: b, d: d, z: a.z + b.z + d.z, area: cross });
      }

      /* Painter's algorithm. Depth sorting by centroid is wrong for triangles
         that interleave, but for a solid mesh viewed from outside it is right
         nearly everywhere and costs nothing. */
      faces.sort((p, q) => p.z - q.z);

      const pad = 24;
      const span = view.bounds.span;
      const scale = Math.min((w - pad * 2) / span, (h - pad * 2) / span);
      const ox = w / 2;
      const oy = h / 2;

      for (let i = 0; i < faces.length; i += 1) {
        const f = faces[i];
        /* Shade from the face's own tilt: the flatter it lies to the light,
           the brighter. Derived from the rotated geometry so it updates as
           the model turns without recomputing any normals. */
        const nz = f.area / (Math.hypot(f.b.x - f.a.x, f.b.y - f.a.y) *
          Math.hypot(f.d.x - f.a.x, f.d.y - f.a.y) + 1e-6);
        const light = 0.32 + 0.62 * Math.max(0, Math.min(1, nz));
        ctx.fillStyle =
          'rgb(' + Math.round(96 + 110 * light) + ',' +
          Math.round(112 + 118 * light) + ',' +
          Math.round(190 + 60 * light) + ')';
        ctx.beginPath();
        ctx.moveTo(ox + f.a.x * scale, oy - f.a.y * scale);
        ctx.lineTo(ox + f.b.x * scale, oy - f.b.y * scale);
        ctx.lineTo(ox + f.d.x * scale, oy - f.d.y * scale);
        ctx.closePath();
        ctx.fill();
      }
    }

    function preview(tris, m) {
      if (!canvas) return;
      view.tris = tris;
      const half = m.size.map((v) => v / 2);
      view.bounds = {
        centre: [m.min[0] + half[0], m.min[1] + half[1], m.min[2] + half[2]],
        /* One scale for all three axes, so a tall part looks tall. */
        span: Math.max(m.size[0], m.size[1], m.size[2]) || 1,
      };
      canvas.setAttribute('aria-label',
        ((window.themeStrings || {}).printingView || 'Preview of your model'));
      draw();
    }

    if (canvas) {
      let dragging = false;
      let last = null;
      const start = (e) => {
        dragging = true;
        last = e.touches ? e.touches[0] : e;
      };
      const move = (e) => {
        if (!dragging || !view.tris) return;
        const p = e.touches ? e.touches[0] : e;
        view.yaw += (p.clientX - last.clientX) * 0.01;
        view.pitch = Math.max(-1.4, Math.min(1.4, view.pitch + (p.clientY - last.clientY) * 0.01));
        last = p;
        e.preventDefault();
        draw();
      };
      const end = () => { dragging = false; };

      canvas.addEventListener('mousedown', start);
      window.addEventListener('mousemove', move);
      window.addEventListener('mouseup', end);
      canvas.addEventListener('touchstart', start, { passive: true });
      canvas.addEventListener('touchmove', move, { passive: false });
      canvas.addEventListener('touchend', end);

      /* The first draw can happen before the browser has settled the layout,
         in which case the canvas still reports its markup size and the model
         is drawn to the wrong scale — and nothing would put it right until
         somebody dragged it. Watching the box covers that, and the ordinary
         window resize, with one thing. */
      if ('ResizeObserver' in window) {
        new ResizeObserver(() => draw()).observe(canvas);
      } else {
        window.addEventListener('resize', draw);
      }
    }

    /* ------------------------------------------------------------- view */

    const str = window.themeStrings || {};
    const mat = () => $('[data-pq-material]', root);
    const infillSel = () => $('[data-pq-infill]', root);

    const money = (n) =>
      window.moneyFormat
        ? window.moneyFormat.replace(/\{\{\s*amount\s*\}\}/, n.toFixed(2))
        : n.toFixed(2);

    function fail(message) {
      err.textContent = message;
      err.hidden = false;
      out.hidden = true;
      model = null;
    }

    function price() {
      if (!model) return;
      const opt = mat().selectedOptions[0];
      const density = parseFloat(opt.dataset.density) || 1.24;
      const multiplier = (parseFloat(opt.dataset.multiplier) || 100) / 100;
      const infill = (parseFloat(infillSel().value) || 20) / 100;

      const g = grams(model.mm3, density, infill, multiplier);
      const h = hours(model.mm3, model.size[2], infill);

      /* Weight and time both get a say, and whichever asks for more wins.
         Not added together: the per-gram rate is already set so that a normal
         part costs about the same either way, so adding them would charge
         twice for the same hour. Taking the greater leaves ordinary parts
         priced by weight and catches the slow ones — a tall thin thing that
         weighs nothing and occupies the machine all afternoon. */
      const byWeight = Math.max(cfg.minGrams, Math.ceil(g)) * cfg.perGram;
      const byTime = h * cfg.hourly;

      /* Everything is charged through the quantity, because that is the only
         number a storefront can set. So the fee and any time premium have to
         be expressed in grams too — otherwise the page shows them and the cart
         never takes them, and the customer is quoted one figure and billed a
         smaller one. */
      const billed = cfg.perGram > 0 ? Math.ceil(Math.max(byWeight, byTime) / cfg.perGram) : 0;
      const feeGrams = cfg.perGram > 0 ? Math.ceil(cfg.handling / cfg.perGram) : 0;
      const qtyValue = billed + feeGrams;

      /* Derived from the quantity rather than worked out alongside it, so the
         shown price is arithmetically the same thing the cart will charge. */
      const total = qtyValue * cfg.perGram;

      $('[data-pq-weight]', root).textContent = g.toFixed(1) + ' g';
      const t = $('[data-pq-time]', root);
      if (t) {
        /* Rounded generously and shown as "about", because it is a guide and
           a precise-looking number invites being held to it. */
        t.textContent = h < 1 ? Math.round(h * 60) + ' min' : h.toFixed(1) + ' h';
      }
      $('[data-pq-price]', root).textContent = money(total);

      const qty = $('[data-pq-qty]', root);
      if (qty) qty.value = String(qtyValue);
      const set = (sel, value) => {
        const el = $(sel, root);
        if (el) el.value = value;
      };
      set('[data-pq-prop-material]', opt.value);
      set('[data-pq-prop-infill]', infillSel().value + '%');
      set('[data-pq-prop-size]', model.size.map((n) => Math.round(n)).join(' x ') + ' mm');
      set('[data-pq-prop-weight]', g.toFixed(1) + ' g (estimated)');
      set('[data-pq-prop-time]', (h < 1 ? Math.round(h * 60) + ' min' : h.toFixed(1) + ' h') + ' (estimated)');
    }

    function show(name, m, tris) {
      model = m;
      preview(tris, m);
      err.hidden = true;
      out.hidden = false;
      $('[data-pq-name]', root).textContent = name;
      $('[data-pq-size]', root).textContent =
        m.size.map((n) => Math.round(n)).join(' × ') + ' mm';
      $('[data-pq-volume]', root).textContent = (m.mm3 / 1000).toFixed(1) + ' cm³';
      price();
    }

    /* ------------------------------------------------------------ input */

    async function take(f) {
      if (!f) return;

      if (f.size > cfg.maxBytes) {
        /* Checked here rather than letting Shopify reject it after an upload
           that could take a minute on a phone. */
        fail(
          (str.printTooBig || 'That file is [n] MB, and the limit is [max] MB.')
            .replace('[n]', (f.size / 1048576).toFixed(1))
            .replace('[max]', String(Math.round(cfg.maxBytes / 1048576)))
        );
        return;
      }

      let tris = null;
      let m = null;
      try {
        const buf = await f.arrayBuffer();
        tris = parseBinary(buf);
        if (!tris) tris = parseAscii(new TextDecoder().decode(buf));
        if (tris) m = measure(tris);
      } catch (e) {
        /* A malformed file is a normal thing for a customer to have, not an
           exception to leak. Whatever went wrong, the answer is the same. */
        tris = null;
      }
      if (!tris || !m) {
        fail(str.printNotStl || 'That does not read as an STL file.');
        return;
      }

      if (!(m.mm3 > 0)) {
        fail(str.printEmpty || 'That model has no volume — it may be a surface rather than a solid.');
        return;
      }

      const over = m.size.some((v, i) => cfg.bed[i] > 0 && v > cfg.bed[i]);
      if (over) {
        fail(
          (str.printTooBig2 || 'That is [size] mm and the printer takes [bed] mm.')
            .replace('[size]', m.size.map((n) => Math.round(n)).join(' × '))
            .replace('[bed]', cfg.bed.join(' × '))
        );
        return;
      }

      show(f.name, m, tris);

      /* The same file is copied onto the form input that actually posts, so
         the customer picks it once and it rides along with the order. */
      if (carry) {
        const dt = new DataTransfer();
        dt.items.add(f);
        carry.files = dt.files;
      }
    }

    file.addEventListener('change', () => take(file.files[0]));

    const drop = $('[data-pq-drop]', root);
    if (drop) {
      ['dragenter', 'dragover'].forEach((e) =>
        drop.addEventListener(e, (ev) => {
          ev.preventDefault();
          drop.dataset.over = 'true';
        })
      );
      ['dragleave', 'drop'].forEach((e) =>
        drop.addEventListener(e, () => {
          drop.dataset.over = 'false';
        })
      );
      drop.addEventListener('drop', (ev) => {
        ev.preventDefault();
        const f = ev.dataTransfer.files[0];
        if (!f) return;
        const dt = new DataTransfer();
        dt.items.add(f);
        file.files = dt.files;
        take(f);
      });
    }

    [mat(), infillSel()].forEach((el) => el && el.addEventListener('change', price));

    const clear = $('[data-pq-clear]', root);
    if (clear) {
      clear.addEventListener('click', () => {
        file.value = '';
        if (carry) carry.value = '';
        model = null;
        out.hidden = true;
        err.hidden = true;
      });
    }
  });

  /* ------------------------------------------------- discord checkout ask */

  /* Shown on every attempt to check out without a connection, up to a limit.
     The dialog is only on the page when there is something to ask about — the
     snippet leaves it out entirely once connected, or when no worker is
     configured — so its presence is the condition.

     Two frequencies, chosen in theme settings. "Every checkout" counts in
     localStorage so the limit spans visits — most people press checkout once
     a visit, so a session-scoped tally would never reach a limit of two and
     the prompt would return on every visit forever. "Once a visit" is the
     earlier behaviour and counts in sessionStorage instead, which is the same
     logic with a limit of one and a shorter memory. */
  const gate = $('[data-discord-gate]');
  if (gate) {
    const perVisit = gate.dataset.mode === 'session';
    const max = perVisit ? 1 : Math.max(0, Number(gate.dataset.max) || 0);

    /* Two shapes behind one counter. Asking once a visit is the same thing as
       a limit of one that forgets itself when the tab closes, so the only
       difference is which store it counts in. */
    const KEY = perVisit ? 'picovr-discord-asked' : 'picovr-discord-asks';
    const store = () => (perVisit ? sessionStorage : localStorage);

    const seen = () => {
      try {
        return Number(store().getItem(KEY)) || 0;
      } catch (e) {
        /* Private mode: no memory, so it simply asks each time. */
        return 0;
      }
    };
    const bump = () => {
      try {
        store().setItem(KEY, String(seen() + 1));
      } catch (e) {
        /* nothing to do */
      }
    };

    /* What they were doing when we interrupted, so declining carries on with
       exactly that rather than guessing at a destination. */
    let pending = null;

    const proceed = () => {
      const go = pending;
      pending = null;
      if (!go) return;
      if (go.tagName === 'A') window.location.href = go.href;
      else go.click();
    };

    $$('[data-checkout]').forEach((btn) => {
      btn.addEventListener(
        'click',
        (e) => {
          if (pending) return;
          if (max === 0 || seen() >= max) return;

          e.preventDefault();
          pending = btn;
          /* Counted when shown rather than when declined, so dismissing it by
             any route still uses one up — otherwise pressing Escape would be
             an unlimited way to keep being asked. */
          bump();
          gate.showModal();
        },
        /* Capture, so this runs before the drawer's own save-and-go handler
           and only one thing is ever in flight. */
        true
      );
    });

    const skip = $('[data-discord-gate-skip]', gate);
    if (skip) skip.addEventListener('click', () => gate.close());

    /* Escape and the backdrop mean the same as "no thanks": close, and still
       go where they were going, or the checkout button appears broken. */
    gate.addEventListener('click', (e) => {
      if (e.target === gate) gate.close();
    });

    new MutationObserver(() => {
      if (!gate.open && pending) proceed();
    }).observe(gate, { attributes: true, attributeFilter: ['open'] });
  }

  /* --------------------------------------------- discord oauth return */

  /* Runs after the capture module above, deliberately: that module's sync()
     rewrites the hint from the field contents, so a message set before it
     initialises would be wiped straight away.

     The worker has no Shopify session and cannot touch the cart, so it hands
     the username back in the query string. That is stored here, then cleared
     from the address bar so a refresh or a shared link does not carry it. */
  (function discordReturn() {
    const q = new URLSearchParams(window.location.search);
    const name = q.get('discord_user');
    const uid = q.get('discord_id');
    const failed = q.get('discord_error');
    if (!name && !failed) return;

    const str = window.themeStrings || {};

    if (name) {
      const first = $('[data-discord-capture]');
      const attr = first ? first.dataset.field : 'Discord username';
      const body = { attributes: {} };
      body.attributes[attr] = name;
      /* The id alongside the handle: handles can be changed afterwards, and
         then an order carrying only a name points at nobody. */
      if (uid) body.attributes[attr + ' ID'] = uid;
      fetch((window.routes && window.routes.cart_update_url) || '/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      }).catch(() => {});
    }

    $$('[data-discord-capture]').forEach((box) => {
      const input = $('[data-discord-input]', box);
      const note = $('[data-discord-hint]', box);
      if (name && input) input.value = name;
      if (!note) return;
      if (name) {
        note.textContent = (str.discordLinked || 'Connected as [n].').replace('{{ name }}', name);
        box.dataset.state = 'ok';
      } else {
        note.textContent =
          failed === 'cancelled'
            ? str.discordLinkCancelled || 'No problem, you can type it in instead.'
            : str.discordLinkFailed || 'That did not go through. Type your username instead.';
        box.dataset.state = 'warn';
      }
      note.hidden = false;
    });

    ['discord_user', 'discord_id', 'discord_ok', 'discord_error'].forEach((k) => q.delete(k));
    const rest = q.toString();
    window.history.replaceState({}, '', window.location.pathname + (rest ? '?' + rest : ''));
  })();

  /* ------------------------------------------------------------ back */

  /* Shown only when going back lands somewhere on this shop.

     history.length is not a usable test — it counts the whole tab, so a
     visitor who arrived here straight from Discord still has entries behind
     them and "back" would throw them out of the site. The referrer is the
     honest signal: same origin means we sent them here ourselves. */
  const backWrap = $('[data-back]');
  if (backWrap) {
    /* A tool page renders a real link to its parent and is already visible.
       If they arrived from that exact page, going back through history is
       better than navigating to it again — same destination, but their scroll
       position is restored rather than reset to the top. */
    const parent = $('[data-back-parent]', backWrap);
    if (parent) {
      parent.addEventListener('click', (e) => {
        let sameParent = false;
        try {
          const from = new URL(document.referrer);
          sameParent =
            from.origin === window.location.origin &&
            from.pathname === parent.getAttribute('data-back-parent');
        } catch (err) {
          sameParent = false;
        }
        if (sameParent) {
          e.preventDefault();
          window.history.back();
        }
      });
    }

    /* Everything below is the history fallback for pages with no parent. A
       tool page has already said where it goes, and rewriting that label from
       the referrer would replace "Back to tools" with wherever they happened
       to come from. */
    let cameFromHere = false;
    try {
      cameFromHere =
        !parent &&
        !!document.referrer &&
        new URL(document.referrer).origin === window.location.origin &&
        new URL(document.referrer).href !== window.location.href;
    } catch (e) {
      cameFromHere = false;
    }

    if (cameFromHere) {
      /* `S` elsewhere in this file is declared inside its own block, so it is
         not in scope here — reading it threw a ReferenceError that the catch
         below then hid, and the label silently stayed generic. */
      const str = window.themeStrings || {};
      const label = $('[data-back-label]', backWrap);

      /* Name the destination when it is a page worth naming, so the control
         says where it goes instead of only which direction. */
      if (label) {
        try {
          const from = new URL(document.referrer);
          const seg = from.pathname.split('/').filter(Boolean);
          const named = {
            collections: str.backToShop,
            products: str.backToProduct,
            blogs: str.backToBlog,
          };
          if (from.pathname === '/' && str.backToHome) {
            label.textContent = str.backToHome;
          } else if (seg.length && named[seg[0]]) {
            label.textContent = named[seg[0]];
          }
        } catch (e) {
          /* A referrer we cannot parse: keep the generic label. */
        }
      }

      backWrap.hidden = false;
      const btn = $('[data-back-btn]', backWrap);
      if (btn) btn.addEventListener('click', () => window.history.back());
    }
  }

  /* -------------------------------------------------- avatars that 404 */

  /* A missing avatar should leave no trace rather than a broken-image glyph.
     These are re-hosted, so it should not happen — but the one thing worse
     than no picture is a torn-page icon next to someone's name.

     `error` does not bubble, so this has to listen in the capture phase, and
     it is registered once for the document rather than per image. */
  document.addEventListener(
    'error',
    (e) => {
      const img = e.target;
      if (!(img instanceof HTMLImageElement)) return;

      if (img.classList.contains('rmodal__pfp')) {
        img.hidden = true;
        return;
      }
      if (!img.classList.contains('review__pfp')) return;

      /* Swap in the same initial the template would have rendered had there
         been no avatar at all, so the row keeps its height and alignment. */
      const card = img.closest('[data-review]');
      const name = card ? card.querySelector('.review__name') : null;
      const span = document.createElement('span');
      span.className = 'review__pfp review__pfp--none';
      span.setAttribute('aria-hidden', 'true');
      span.textContent = name ? name.textContent.trim().charAt(0).toUpperCase() : '';
      img.replaceWith(span);
    },
    true
  );

  /* The listener above only catches failures that happen after this script
     runs, and it is deferred — an avatar can have given up long before then.
     A sweep once everything has settled catches those, using naturalWidth
     rather than an event, so it does not depend on having been listening at
     the right moment. */
  window.addEventListener('load', () => {
    $$('.review__pfp').forEach((img) => {
      if (img.tagName !== 'IMG') return;
      if (img.complete && img.naturalWidth === 0) {
        img.dispatchEvent(new Event('error'));
      }
    });
  });

  /* ------------------------------------------------------ review pop-out */

  /* Deliberately its own pass rather than part of the block above, which
     returns early when there is only one page of reviews — the pop-out has
     nothing to do with paging and must work either way. */
  $$('[data-review-modal]').forEach((modal) => {
    const root = modal.closest('[data-reviews]') || document;
    const body = $('[data-rmodal-body]', modal);
    const pfp = $('[data-rmodal-pfp]', modal);
    const nameEl = $('[data-rmodal-name]', modal);
    const metaEl = $('[data-rmodal-meta]', modal);
    if (!body) return;

    function open(card) {
      const tpl = $('[data-review-full]', card);
      if (!tpl) return;

      body.replaceChildren(tpl.content.cloneNode(true));

      const name = $('.review__name', card);
      nameEl.textContent = name ? name.textContent.trim() : '';

      const detail = $('.review__detail', card);
      const date = $('.review__date', card);
      metaEl.textContent = [detail, date]
        .filter(Boolean)
        .map((el) => el.textContent.trim())
        .join(' · ');

      const shot = $('.review__pfp', card);
      if (shot && shot.tagName === 'IMG') {
        pfp.src = shot.src;
        pfp.hidden = false;
      } else {
        pfp.removeAttribute('src');
        pfp.hidden = true;
      }

      modal.showModal();
      body.scrollTop = 0;
    }

    $$('[data-review-open]', root).forEach((btn) => {
      btn.addEventListener('click', () => {
        const card = btn.closest('[data-review]');
        if (card) open(card);
      });
    });

    const close = $('[data-review-close]', modal);
    if (close) close.addEventListener('click', () => modal.close());

    /* Clicking the backdrop reports the dialog itself as the target, since the
       backdrop is not an element of its own. Anything inside reports that
       child, so this only fires on the area outside the panel. */
    modal.addEventListener('click', (e) => {
      if (e.target === modal) modal.close();
    });

    /* Emptying on close stops a video carrying on playing behind the scenes
       and lets the browser release whatever media was loaded.

       Watching the attribute rather than listening for the `close` event:
       both close() and the Escape key clear `open`, whereas the event did
       not fire at all in one browser this was tested in — and a video still
       playing under a closed dialog is exactly the failure you do not hear
       about until someone complains. */
    new MutationObserver(() => {
      if (modal.open) return;
      $$('video', body).forEach((v) => v.pause());
      body.replaceChildren();
    }).observe(modal, { attributes: true, attributeFilter: ['open'] });
  });

  /* ----------------------------------------------------- guide deep links */

  /* A step inside a shut dropdown cannot be linked to: the browser scrolls to
     something it will not show, and the reader arrives at an apparently empty
     stretch of page. Support gets given links to single steps often enough
     for this to be worth a few lines. */
  function openToHash() {
    var hash = window.location.hash;
    if (hash.length < 2) return;
    var target;
    try {
      target = document.getElementById(decodeURIComponent(hash.slice(1)));
    } catch (err) {
      /* A malformed hash is not worth taking the rest of the file down for. */
      return;
    }
    if (!target) return;

    /* Walk outwards, in case a panel ever ends up inside another one. */
    var box = target.closest('details');
    while (box) {
      box.open = true;
      box = box.parentElement ? box.parentElement.closest('details') : null;
    }

    /* Scrolled again deliberately: by the time this runs the browser has
       already tried and failed to reach the hash, and opening the panel has
       moved everything below it anyway. */
    target.scrollIntoView({ block: 'start' });
  }

  window.addEventListener('hashchange', openToHash);
  if (window.location.hash) openToHash();

  /* --------------------------------------------------------------- reveal */

  const revealables = $$('[data-reveal]');

  if (revealables.length && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -10% 0px' }
    );
    revealables.forEach((el) => io.observe(el));
  } else {
    revealables.forEach((el) => el.classList.add('is-visible'));
  }
})();
